var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _g7, _path120, _g8, _path121, _g9, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _g10, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _g11, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _g12, _path283, _path284, _g13, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _g14, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _g15, _path302, _path303, _g16, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _g17, _path313, _path314, _path315, _path316, _path317, _g18, _path318, _path319, _path320, _path321, _path322, _g19, _path323;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1866 18.1411C128.62 8.14684 163.834 48.8764 176.681 63.0508C189.571 77.2711 202.46 91.4909 215.35 105.711C227.06 118.63 239.093 132.129 242.97 147.986C247.781 167.67 245.015 201.644 228.584 216.358C212.152 231.071 189.08 239.877 165.359 243.585C141.637 247.293 117.179 246.215 93.2694 243.463C79.44 241.872 65.5418 239.685 52.8332 234.875C40.1246 230.066 28.579 222.385 22.2769 212.017C14.7063 199.562 15.4355 184.727 18.6589 171.029C21.8817 157.331 27.4118 143.974 28.935 130.073C30.2561 118.023 5.15996 32.1369 77.1866 18.1411Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M77.1866 18.1411C128.62 8.14684 163.834 48.8764 176.681 63.0508C189.571 77.2711 202.46 91.4909 215.35 105.711C227.06 118.63 239.093 132.129 242.97 147.986C247.781 167.67 245.015 201.644 228.584 216.358C212.152 231.071 189.08 239.877 165.359 243.585C141.637 247.293 117.179 246.215 93.2694 243.463C79.44 241.872 65.5418 239.685 52.8332 234.875C40.1246 230.066 28.579 222.385 22.2769 212.017C14.7063 199.562 15.4355 184.727 18.6589 171.029C21.8817 157.331 27.4118 143.974 28.935 130.073C30.2561 118.023 5.15996 32.1369 77.1866 18.1411Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.216 232.467H18.9998",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.165 232.467V31.9991H159.642C158.298 50.6627 147.958 67.5056 131.924 77.1516L131.108 77.6428V232.467H221.165Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.692 46.6057C164.634 47.395 164.352 48.1691 164.008 48.9229C163.608 49.7972 163.558 50.6533 162.992 51.4833C165.646 51.6206 167.646 51.821 168.649 51.6895C169.763 50.1036 169.812 47.8622 169.568 46.1093C167.982 46.5812 166.086 46.114 164.455 46.5055L164.692 46.6057Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.744 45.9339C164.588 46.7133 164.21 47.4576 163.772 48.1775C163.265 49.0121 162.675 49.8212 162.007 50.5975C164.634 50.9603 166.668 50.8898 167.684 50.8449C168.993 49.3645 169.592 47.8716 169.569 46.1093C167.678 46.0524 164.744 45.9339 164.744 45.9339Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.402 53.2696C156.344 54.0588 156.062 54.8324 155.718 55.5867C155.319 56.4611 155.541 57.3172 154.976 58.1471C157.63 58.2849 159.63 58.4849 160.633 58.3533C161.747 56.7675 161.522 54.526 161.279 52.7731C159.693 53.245 157.796 52.7778 156.165 53.1693L156.402 53.2696Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.454 52.5978C156.297 53.3771 155.919 54.1215 155.482 54.8413C154.975 55.676 154.385 56.4851 153.717 57.2613C156.343 57.6241 158.378 57.5536 159.394 57.5087C160.703 56.0283 161.301 54.5354 161.279 52.7732C159.388 52.7163 156.454 52.5978 156.454 52.5978Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.462 46.1803C173.405 46.9696 173.122 47.7432 172.778 48.4974C172.379 49.3718 172.296 50.2279 171.73 51.0579C174.385 51.1957 176.384 51.3956 177.387 51.264C178.502 49.6782 178.583 47.4367 178.339 45.6839C176.753 46.1558 174.856 45.6886 173.225 46.0801L173.462 46.1803Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.514 45.509C173.358 46.2883 172.98 47.0327 172.542 47.7526C172.035 48.5872 171.445 49.3963 170.778 50.1725C173.404 50.5353 175.438 50.4649 176.454 50.42C177.764 48.9396 178.362 47.4467 178.339 45.6844C176.449 45.6275 173.514 45.509 173.514 45.509Z",
    fill: "#92E3A9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.853 90.2726C205.795 91.0619 205.513 91.836 205.169 92.5898C204.77 93.4641 204.686 94.3202 204.121 95.1496C206.775 95.2875 208.774 95.4874 209.778 95.3558C210.892 93.77 210.973 91.5285 210.729 89.7757C209.144 90.2475 207.247 89.7803 205.616 90.1718L205.853 90.2726Z",
    fill: "black"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.905 89.6008C205.748 90.3801 205.371 91.1245 204.933 91.8443C204.426 92.679 203.836 93.4881 203.168 94.2643C205.794 94.6271 207.829 94.5567 208.845 94.5118C210.154 93.0314 210.752 91.5384 210.73 89.7762C208.839 89.7198 205.905 89.6008 205.905 89.6008Z",
    fill: "#92E3A9"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.513 91.9618C195.456 92.7511 195.173 93.5247 194.829 94.2789C194.43 95.1533 194.346 96.0094 193.781 96.8394C196.435 96.9772 198.435 97.1771 199.438 97.0455C200.552 95.4597 200.633 93.2182 200.39 91.4654C198.804 91.9373 196.908 91.4701 195.277 91.8616L195.513 91.9618Z",
    fill: "black"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.565 91.29C195.409 92.0693 195.031 92.8137 194.593 93.5335C194.086 94.3682 193.496 95.1773 192.828 95.9535C195.455 96.3163 197.489 96.2458 198.505 96.201C199.814 94.7206 200.413 93.2276 200.39 91.4654C198.499 91.409 195.565 91.29 195.565 91.29Z",
    fill: "#92E3A9"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.241 90.3603C186.184 91.1495 185.901 91.9232 185.557 92.6774C185.158 93.5518 185.075 94.4079 184.509 95.2378C187.164 95.3757 189.163 95.5756 190.166 95.444C191.281 93.8582 191.362 91.6167 191.118 89.8639C189.532 90.3357 187.636 89.8686 186.005 90.2601L186.241 90.3603Z",
    fill: "black"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.294 89.6885C186.137 90.4678 185.759 91.2122 185.322 91.932C184.815 92.7667 184.225 93.5758 183.557 94.352C186.183 94.7148 188.218 94.6443 189.234 94.5995C190.543 93.1191 191.141 91.6261 191.119 89.8639C189.228 89.807 186.294 89.6885 186.294 89.6885Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.896 41.4374H180.495V86.131H210.896V41.4374Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.663 85.5694H178.762L180.259 67.8344C180.518 64.7619 180.618 61.678 180.558 58.595L180.212 40.8757H210.453L210.596 62.6102C210.608 64.3626 210.573 66.115 210.491 67.8657L209.663 85.5694Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M208.377 84.967H177.144L178.102 79.9944C180.14 67.8339 180.648 62.4489 180.366 46.6898L180.045 40.2739H209.669L210.018 46.3322C210.766 72.7031 208.377 84.967 208.377 84.967Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.799 42.5279C181.354 42.5279 180.993 42.1661 180.993 41.7219C180.993 41.2777 181.354 40.9159 181.799 40.9159C181.865 40.9159 181.919 40.9697 181.919 41.036C181.919 41.1023 181.865 41.156 181.799 41.156C181.487 41.156 181.233 41.4097 181.233 41.7214C181.233 42.033 181.487 42.2867 181.799 42.2867C182.11 42.2867 182.364 42.033 182.364 41.7214C182.364 41.6551 182.418 41.6013 182.484 41.6013C182.55 41.6013 182.604 41.6551 182.604 41.7214C182.604 42.1661 182.243 42.5279 181.799 42.5279Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.779 42.1948C181.042 42.1948 181.002 40.6032 181.001 40.2843V40.2739C181.001 39.9534 181.039 38.3529 181.779 38.3529C182.517 38.3529 182.57 40.0802 182.574 40.2775L181.933 40.2895C181.924 39.802 181.849 39.4235 181.774 39.1938C181.707 39.4162 181.643 39.7848 181.643 40.2739V40.2838C181.644 40.7792 181.71 41.1498 181.779 41.3695C181.786 41.3461 181.794 41.3205 181.802 41.2923L181.853 41.1179L182.299 41.2484C182.392 41.2756 182.446 41.3732 182.419 41.4666C182.288 41.9474 182.072 42.1948 181.779 42.1948Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.484 41.8419C182.418 41.8419 182.364 41.7882 182.364 41.7219C182.364 41.4103 182.111 41.1566 181.799 41.1566C181.733 41.1566 181.679 41.1028 181.679 41.0365C181.679 40.9702 181.733 40.9164 181.799 40.9164C182.243 40.9164 182.605 41.2782 182.605 41.7224C182.604 41.7882 182.551 41.8419 182.484 41.8419Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.599 42.5279C185.154 42.5279 184.793 42.1661 184.793 41.7219C184.793 41.2777 185.154 40.9159 185.599 40.9159C185.665 40.9159 185.719 40.9697 185.719 41.036C185.719 41.1023 185.665 41.156 185.599 41.156C185.287 41.156 185.033 41.4097 185.033 41.7214C185.033 42.033 185.287 42.2867 185.599 42.2867C185.91 42.2867 186.164 42.033 186.164 41.7214C186.164 41.6551 186.218 41.6013 186.284 41.6013C186.35 41.6013 186.404 41.6551 186.404 41.7214C186.405 42.1661 186.043 42.5279 185.599 42.5279Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.58 42.1948C184.843 42.1948 184.803 40.6032 184.802 40.2843V40.2739C184.802 39.9534 184.84 38.3529 185.58 38.3529C186.318 38.3529 186.371 40.0802 186.375 40.2775L185.734 40.2895C185.725 39.802 185.65 39.4235 185.575 39.1938C185.508 39.4162 185.444 39.7848 185.444 40.2739V40.2838C185.445 40.7792 185.511 41.1498 185.58 41.3695C185.587 41.3461 185.595 41.3205 185.603 41.2923L185.653 41.1179L186.1 41.2484C186.193 41.2756 186.247 41.3732 186.22 41.4666C186.088 41.9474 185.873 42.1948 185.58 42.1948Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.285 41.8419C186.218 41.8419 186.165 41.7882 186.165 41.7219C186.165 41.4103 185.911 41.1566 185.599 41.1566C185.533 41.1566 185.479 41.1028 185.479 41.0365C185.479 40.9702 185.533 40.9164 185.599 40.9164C186.043 40.9164 186.405 41.2782 186.405 41.7224C186.405 41.7882 186.351 41.8419 186.285 41.8419Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.399 42.5279C188.955 42.5279 188.593 42.1661 188.593 41.7219C188.593 41.2777 188.955 40.9159 189.399 40.9159C189.465 40.9159 189.519 40.9697 189.519 41.036C189.519 41.1023 189.465 41.156 189.399 41.156C189.087 41.156 188.834 41.4097 188.834 41.7214C188.834 42.033 189.087 42.2867 189.399 42.2867C189.711 42.2867 189.964 42.033 189.964 41.7214C189.964 41.6551 190.018 41.6013 190.084 41.6013C190.151 41.6013 190.204 41.6551 190.204 41.7214C190.205 42.1661 189.844 42.5279 189.399 42.5279Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M189.38 42.1948C188.643 42.1948 188.603 40.6032 188.602 40.2843V40.2739C188.602 39.9534 188.64 38.3529 189.38 38.3529C190.118 38.3529 190.171 40.0802 190.175 40.2775L189.534 40.2895C189.525 39.802 189.45 39.4235 189.375 39.1938C189.308 39.4162 189.244 39.7848 189.244 40.2739V40.2838C189.245 40.7792 189.312 41.1498 189.38 41.3695C189.387 41.3461 189.395 41.3205 189.403 41.2923L189.454 41.1179L189.9 41.2484C189.993 41.2756 190.047 41.3732 190.02 41.4666C189.888 41.9474 189.673 42.1948 189.38 42.1948Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.085 41.8419C190.018 41.8419 189.965 41.7882 189.965 41.7219C189.965 41.4103 189.711 41.1566 189.399 41.1566C189.333 41.1566 189.279 41.1028 189.279 41.0365C189.279 40.9702 189.333 40.9164 189.399 40.9164C189.844 40.9164 190.205 41.2782 190.205 41.7224C190.205 41.7882 190.151 41.8419 190.085 41.8419Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193.2 42.5279C192.755 42.5279 192.394 42.1661 192.394 41.7219C192.394 41.2777 192.755 40.9159 193.2 40.9159C193.266 40.9159 193.32 40.9697 193.32 41.036C193.32 41.1023 193.266 41.156 193.2 41.156C192.888 41.156 192.634 41.4097 192.634 41.7214C192.634 42.033 192.888 42.2867 193.2 42.2867C193.511 42.2867 193.765 42.033 193.765 41.7214C193.765 41.6551 193.819 41.6013 193.885 41.6013C193.951 41.6013 194.005 41.6551 194.005 41.7214C194.005 42.1661 193.644 42.5279 193.2 42.5279Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.18 42.1948C192.443 42.1948 192.403 40.6032 192.402 40.2843V40.2739C192.402 39.9534 192.44 38.3529 193.18 38.3529C193.918 38.3529 193.971 40.0802 193.975 40.2775L193.334 40.2895C193.325 39.802 193.25 39.4235 193.175 39.1938C193.108 39.4162 193.044 39.7848 193.044 40.2739V40.2838C193.045 40.7792 193.111 41.1498 193.18 41.3695C193.187 41.3461 193.195 41.3205 193.203 41.2923L193.254 41.1179L193.7 41.2484C193.793 41.2756 193.847 41.3732 193.82 41.4666C193.688 41.9474 193.473 42.1948 193.18 42.1948Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M193.885 41.8419C193.819 41.8419 193.765 41.7882 193.765 41.7219C193.765 41.4103 193.511 41.1566 193.2 41.1566C193.133 41.1566 193.079 41.1028 193.079 41.0365C193.079 40.9702 193.133 40.9164 193.2 40.9164C193.644 40.9164 194.005 41.2782 194.005 41.7224C194.005 41.7882 193.952 41.8419 193.885 41.8419Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.976 42.5279C196.532 42.5279 196.17 42.1661 196.17 41.7219C196.17 41.2777 196.532 40.9159 196.976 40.9159C197.042 40.9159 197.096 40.9697 197.096 41.036C197.096 41.1023 197.042 41.156 196.976 41.156C196.665 41.156 196.411 41.4097 196.411 41.7214C196.411 42.033 196.665 42.2867 196.976 42.2867C197.288 42.2867 197.541 42.033 197.541 41.7214C197.541 41.6551 197.595 41.6013 197.662 41.6013C197.728 41.6013 197.782 41.6551 197.782 41.7214C197.782 42.1661 197.42 42.5279 196.976 42.5279Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M196.957 42.1948C196.22 42.1948 196.18 40.6032 196.179 40.2843V40.2739C196.179 39.9534 196.216 38.3529 196.957 38.3529C197.695 38.3529 197.748 40.0802 197.752 40.2775L197.111 40.2895C197.102 39.802 197.027 39.4235 196.952 39.1938C196.885 39.4162 196.821 39.7848 196.821 40.2739V40.2838C196.822 40.7792 196.888 41.1498 196.957 41.3695C196.964 41.3461 196.972 41.3205 196.98 41.2923L197.03 41.1179L197.477 41.2484C197.57 41.2756 197.624 41.3732 197.597 41.4666C197.465 41.9474 197.249 42.1948 196.957 42.1948Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.662 41.8419C197.595 41.8419 197.541 41.7882 197.541 41.7219C197.541 41.4103 197.288 41.1566 196.976 41.1566C196.91 41.1566 196.856 41.1028 196.856 41.0365C196.856 40.9702 196.91 40.9164 196.976 40.9164C197.42 40.9164 197.782 41.2782 197.782 41.7224C197.782 41.7882 197.728 41.8419 197.662 41.8419Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M200.776 42.5279C200.332 42.5279 199.97 42.1661 199.97 41.7219C199.97 41.2777 200.332 40.9159 200.776 40.9159C200.843 40.9159 200.896 40.9697 200.896 41.036C200.896 41.1023 200.843 41.156 200.776 41.156C200.464 41.156 200.211 41.4097 200.211 41.7214C200.211 42.033 200.465 42.2867 200.776 42.2867C201.088 42.2867 201.342 42.033 201.342 41.7214C201.342 41.6551 201.395 41.6013 201.462 41.6013C201.528 41.6013 201.582 41.6551 201.582 41.7214C201.582 42.1661 201.221 42.5279 200.776 42.5279Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200.757 42.1948C200.02 42.1948 199.98 40.6032 199.979 40.2843V40.2739C199.979 39.9534 200.017 38.3529 200.757 38.3529C201.495 38.3529 201.548 40.0802 201.552 40.2775L200.91 40.2895C200.901 39.802 200.826 39.4235 200.752 39.1938C200.684 39.4162 200.62 39.7848 200.62 40.2739V40.2838C200.621 40.7792 200.687 41.1498 200.756 41.3695C200.764 41.3461 200.771 41.3205 200.779 41.2923L200.83 41.1179L201.277 41.2484C201.37 41.2756 201.423 41.3732 201.396 41.4666C201.266 41.9474 201.05 42.1948 200.757 42.1948Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M201.462 41.8419C201.396 41.8419 201.342 41.7882 201.342 41.7219C201.342 41.4103 201.088 41.1566 200.777 41.1566C200.711 41.1566 200.657 41.1028 200.657 41.0365C200.657 40.9702 200.711 40.9164 200.777 40.9164C201.221 40.9164 201.583 41.2782 201.583 41.7224C201.582 41.7882 201.528 41.8419 201.462 41.8419Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M204.576 42.5279C204.132 42.5279 203.771 42.1661 203.771 41.7219C203.771 41.2777 204.132 40.9159 204.576 40.9159C204.643 40.9159 204.697 40.9697 204.697 41.036C204.697 41.1023 204.643 41.156 204.576 41.156C204.265 41.156 204.011 41.4097 204.011 41.7214C204.011 42.033 204.265 42.2867 204.576 42.2867C204.888 42.2867 205.142 42.033 205.142 41.7214C205.142 41.6551 205.196 41.6013 205.262 41.6013C205.328 41.6013 205.382 41.6551 205.382 41.7214C205.382 42.1661 205.021 42.5279 204.576 42.5279Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M204.557 42.1948C203.821 42.1948 203.78 40.6032 203.78 40.2843V40.2739C203.78 39.9534 203.817 38.3529 204.557 38.3529C205.295 38.3529 205.348 40.0802 205.353 40.2775L204.711 40.2895C204.702 39.802 204.627 39.4235 204.552 39.1938C204.485 39.4162 204.421 39.7848 204.421 40.2739V40.2838C204.422 40.7792 204.488 41.1498 204.557 41.3695C204.564 41.3461 204.572 41.3205 204.58 41.2923L204.631 41.1179L205.077 41.2484C205.17 41.2756 205.224 41.3732 205.197 41.4666C205.066 41.9474 204.85 42.1948 204.557 42.1948Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M205.262 41.8419C205.196 41.8419 205.142 41.7882 205.142 41.7219C205.142 41.4103 204.889 41.1566 204.577 41.1566C204.511 41.1566 204.457 41.1028 204.457 41.0365C204.457 40.9702 204.511 40.9164 204.577 40.9164C205.021 40.9164 205.383 41.2782 205.383 41.7224C205.382 41.7882 205.329 41.8419 205.262 41.8419Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M208.377 42.5279C207.932 42.5279 207.571 42.1661 207.571 41.7219C207.571 41.2777 207.932 40.9159 208.377 40.9159C208.443 40.9159 208.497 40.9697 208.497 41.036C208.497 41.1023 208.443 41.156 208.377 41.156C208.065 41.156 207.811 41.4097 207.811 41.7214C207.811 42.033 208.065 42.2867 208.377 42.2867C208.688 42.2867 208.942 42.033 208.942 41.7214C208.942 41.6551 208.996 41.6013 209.062 41.6013C209.128 41.6013 209.182 41.6551 209.182 41.7214C209.183 42.1661 208.821 42.5279 208.377 42.5279Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M208.358 42.1948C207.621 42.1948 207.581 40.6032 207.58 40.2843V40.2739C207.58 39.9534 207.618 38.3529 208.358 38.3529C209.096 38.3529 209.149 40.0802 209.153 40.2775L208.512 40.2895C208.503 39.802 208.428 39.4235 208.353 39.1938C208.286 39.4162 208.221 39.7848 208.221 40.2739V40.2838C208.223 40.7792 208.289 41.1498 208.358 41.3695C208.365 41.3461 208.373 41.3205 208.381 41.2923L208.431 41.1179L208.878 41.2484C208.971 41.2756 209.025 41.3732 208.998 41.4666C208.866 41.9474 208.651 42.1948 208.358 42.1948Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M209.063 41.8419C208.996 41.8419 208.942 41.7882 208.942 41.7219C208.942 41.4103 208.689 41.1566 208.377 41.1566C208.311 41.1566 208.257 41.1028 208.257 41.0365C208.257 40.9702 208.311 40.9164 208.377 40.9164C208.821 40.9164 209.183 41.2782 209.183 41.7224C209.183 41.7882 209.129 41.8419 209.063 41.8419Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M189.375 39.1939H194.005V35.9804C194.005 35.3801 194.492 34.8936 195.092 34.8936C195.692 34.8936 196.179 35.3801 196.179 35.9804V39.1939H200.751",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M189.375 39.1939H194.005V35.9804C194.005 35.3801 194.492 34.8936 195.092 34.8936C195.692 34.8936 196.179 35.3801 196.179 35.9804V39.1939H200.751",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M192.342 44.6618V45.3811H191.515V49.6975H190.724V45.3811H189.896V44.6618H192.342Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M194.45 49.697L194.313 48.7835H193.342L193.205 49.697H192.478L193.284 44.6618H194.442L195.248 49.697H194.45ZM194.205 48.1002L193.824 45.5539L193.443 48.1002H194.205Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M195.809 44.9311C196.006 44.7129 196.296 44.6039 196.68 44.6039C197.063 44.6039 197.354 44.7135 197.55 44.9311C197.747 45.1493 197.845 45.4625 197.845 45.8702V46.0284H197.097V45.8196C197.097 45.6473 197.063 45.521 196.997 45.4417C196.929 45.3628 196.831 45.3232 196.702 45.3232C196.572 45.3232 196.474 45.3628 196.407 45.4417C196.339 45.521 196.306 45.6468 196.306 45.8196C196.306 46.0305 196.362 46.2153 196.475 46.3734C196.588 46.5316 196.757 46.7117 196.983 46.9132C197.169 47.0854 197.32 47.2379 197.436 47.3699C197.55 47.502 197.649 47.6612 197.731 47.8481C197.812 48.035 197.853 48.2485 197.853 48.4886C197.853 48.8963 197.753 49.2089 197.55 49.4271C197.349 49.6453 197.057 49.7544 196.673 49.7544C196.289 49.7544 195.996 49.6453 195.795 49.4271C195.594 49.2089 195.493 48.8957 195.493 48.4886V48.179H196.241V48.5387C196.241 48.8649 196.378 49.0278 196.651 49.0278C196.925 49.0278 197.061 48.8649 197.061 48.5387C197.061 48.3278 197.005 48.143 196.892 47.9848C196.779 47.8267 196.61 47.6471 196.385 47.4451C196.198 47.2723 196.047 47.1204 195.932 46.9883C195.817 46.8568 195.719 46.6971 195.637 46.5097C195.556 46.3228 195.515 46.1093 195.515 45.8697C195.515 45.4625 195.613 45.1499 195.809 44.9311Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M199.097 48.1503V49.697H198.305V44.6618H199.097V46.8558L200.132 44.6618H200.924L199.823 46.9064L200.924 49.6975H200.11L199.34 47.6904L199.097 48.1503Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M190.316 52.0669C194.343 51.0657 198.497 50.5761 202.647 50.6136L190.316 52.0669Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M190.316 52.0669C194.343 51.0657 198.497 50.5761 202.647 50.6136",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M186.579 67.8611H183.078V71.3621H186.579V67.8611Z",
    stroke: "#92E3A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M186.097 73.5858H182.596V77.0869H186.097V73.5858Z",
    stroke: "#92E3A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M186.739 61.9833H183.238V65.4844H186.739V61.9833Z",
    stroke: "#92E3A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M187.087 56.4454H183.586V59.9465H187.087V56.4454Z",
    stroke: "#92E3A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M184.421 57.6361C184.517 57.6419 184.613 57.6471 184.708 57.6528C184.765 58.4129 185.024 59.1572 185.452 59.7873C185.501 59.8604 185.564 59.9381 185.651 59.946C185.783 59.958 185.866 59.8139 185.915 59.6918C186.568 58.0725 187.159 56.4282 187.684 54.763",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M190.318 65.8581C190.678 65.1414 191.059 64.4346 191.42 63.7174C191.72 63.1202 192 62.4813 192.475 61.9979C192.601 61.8685 192.739 61.7526 192.887 61.6493C192.914 61.6164 192.944 61.6044 192.98 61.6122C192.958 61.7693 192.814 61.8862 192.743 62.023C192.774 62.0658 192.819 62.0794 192.88 62.0637C193.098 62.0616 193.315 62.0653 193.533 62.0742C193.752 62.071 193.95 62.1295 194.129 62.2501C194.263 62.3936 194.304 62.5633 194.254 62.7585C194.165 63.1093 194.02 63.4366 193.822 63.7404C193.627 64.0598 193.397 64.3511 193.132 64.6147C192.929 64.8298 192.703 65.0182 192.456 65.1795C192.347 65.2834 192.243 65.3001 192.146 65.2291C192.046 65.2041 192.019 65.131 192.065 65.0104C192.132 64.8324 192.235 64.6779 192.375 64.5474C192.576 64.3527 192.806 64.2003 193.064 64.0906C193.36 63.9507 193.665 63.8343 193.979 63.7414C194.155 63.6913 194.335 63.6636 194.517 63.6579C194.649 63.6574 194.78 63.6501 194.911 63.6355C195.005 63.6208 195.089 63.5947 195.176 63.5582C194.992 63.7112 194.778 63.8892 194.682 64.1141C194.662 64.1893 194.643 64.265 194.623 64.3402C194.633 64.4075 194.644 64.4754 194.655 64.5427C194.707 64.5803 194.76 64.6179 194.812 64.6554C194.961 64.6753 195.083 64.633 195.178 64.5286C195.265 64.4811 195.329 64.4127 195.371 64.3229C195.427 64.2577 195.466 64.1836 195.484 64.0995C195.522 64.0379 195.532 63.9722 195.514 63.9032C195.528 63.8417 195.508 63.7947 195.457 63.7623C195.432 63.7132 195.392 63.6934 195.339 63.7033C195.292 63.6877 195.249 63.695 195.211 63.7252C195.131 63.7623 195.075 63.815 195.018 63.8818C195.071 63.9017 195.147 63.8474 195.196 63.8265C195.351 63.7592 195.51 63.7049 195.672 63.6532C196.078 63.5232 196.49 63.4167 196.91 63.34C196.869 63.398 196.778 63.4428 196.721 63.4815C196.569 63.5864 196.395 63.6955 196.282 63.8458C196.161 64.0066 196.109 64.2065 196.091 64.4033C196.078 64.5448 196.1 64.7421 196.298 64.7431C196.445 64.7437 196.581 64.6492 196.694 64.5667C196.834 64.4654 196.96 64.3282 197.085 64.2091C197.117 64.1789 197.368 63.9774 197.285 63.8892C197.252 63.9601 197.225 64.0327 197.203 64.1073C197.169 64.1909 197.16 64.276 197.176 64.3631C197.26 64.5004 197.497 64.3302 197.583 64.2765C197.817 64.1314 198.011 63.9137 198.062 63.6318C198.016 63.7493 197.984 63.8667 197.964 63.9915C197.944 64.1167 197.909 64.2676 197.979 64.3809C198.162 64.3605 198.265 64.1763 198.354 64.0317C198.403 63.9513 198.489 63.7524 198.601 63.8035C198.599 63.9079 198.575 63.9983 198.538 64.0969C198.526 64.1293 198.505 64.217 198.465 64.2305C198.468 64.1314 198.571 63.9779 198.642 63.9137C198.695 63.8667 198.757 63.8542 198.827 63.8641C198.958 63.8834 198.993 63.8912 199.13 63.8286C199.245 63.766 199.357 63.6991 199.467 63.6276C199.514 63.5582 199.559 63.5446 199.6 63.5859C199.538 63.7754 199.451 63.9638 199.401 64.1569C199.385 64.2347 199.368 64.3125 199.351 64.3903C199.315 64.4895 199.331 64.573 199.399 64.6408C199.494 64.6314 199.572 64.6069 199.662 64.5725C199.944 64.4634 200.221 64.3355 200.483 64.183C200.677 64.0698 200.845 63.9419 200.988 63.767C201.049 63.7091 201.095 63.6412 201.125 63.5629C201.181 63.4971 201.191 63.4235 201.154 63.3426C201.036 63.2962 200.921 63.3071 200.808 63.376C200.738 63.4141 200.668 63.4522 200.597 63.4903C200.417 63.6015 200.316 63.7654 200.293 63.981C200.237 64.1883 200.282 64.3501 200.428 64.4665C200.507 64.6017 200.629 64.6351 200.795 64.5678C200.983 64.5166 201.153 64.431 201.304 64.3115C201.557 64.1392 201.783 63.9471 201.938 63.6788C201.856 63.6798 201.673 64.0264 201.668 64.0337C201.591 64.171 201.531 64.3156 201.455 64.4534C201.488 64.2504 201.63 64.0823 201.763 63.933C201.905 63.7738 202.084 63.5504 202.307 63.5196C202.328 63.6292 202.281 63.7232 202.243 63.8249C202.217 63.8886 202.195 63.9534 202.175 64.0191C202.139 64.0959 202.13 64.1768 202.146 64.2613C202.26 64.3302 202.366 64.3021 202.463 64.1773C202.621 64.063 202.76 63.9304 202.881 63.7785C203.01 63.6464 203.115 63.4966 203.197 63.3296C203.284 63.2283 203.325 63.1161 203.321 62.9918C203.15 63.1724 203.039 63.3739 202.95 63.6062C202.886 63.7247 202.856 63.8516 202.859 63.9862C202.823 64.1126 202.832 64.2352 202.885 64.3543C202.895 64.5176 202.978 64.6372 203.134 64.7118C203.23 64.7129 203.325 64.7139 203.42 64.7144C203.521 64.6722 203.621 64.6304 203.722 64.5881C203.853 64.515 203.93 64.4096 203.955 64.2728C204 64.1314 204.023 63.9868 203.973 63.8443C203.959 63.7534 203.903 63.696 203.805 63.6715C203.736 63.6501 203.667 63.6287 203.598 63.6078C203.45 63.5702 203.292 63.5483 203.139 63.5399C203.12 63.5389 202.911 63.5206 202.876 63.5812C203.162 63.6318 203.484 63.6031 203.767 63.5509C203.939 63.5196 204.151 63.4679 204.277 63.3358C204.253 63.3322 204.192 63.3259 204.208 63.3682C204.219 63.3959 204.272 63.3781 204.296 63.3797C204.269 63.4131 204.261 63.4522 204.271 63.4961C204.444 63.5994 204.628 63.6804 204.822 63.7393C205.097 63.8244 205.2 63.9836 205.131 64.217C205.157 64.4947 205.028 64.7087 204.742 64.859C204.518 65.1409 204.328 65.1696 204.17 64.9462C204.293 64.6962 204.476 64.5114 204.72 64.3913C204.897 64.2347 205.105 64.1475 205.343 64.1303",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M189.581 57.3516C189.602 57.6189 191.046 57.1413 190.978 57.1606C192.196 56.8056 193.478 56.2413 194.771 56.3264",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M192.079 56.1343C192.109 56.0863 192.149 56.0665 192.201 56.0748C192.193 56.1416 192.166 56.1943 192.143 56.2591C192.031 56.5671 191.985 56.9366 191.917 57.2441C191.791 57.8047 191.644 58.357 191.488 58.9103C191.458 59.0184 191.241 59.5717 191.31 59.7868",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M192.927 57.4158C192.936 57.8115 192.912 58.1832 192.813 58.5679C192.741 58.8451 192.584 59.1541 192.589 59.4422C192.987 58.926 193.197 58.2129 193.873 57.9801C194.019 58.2041 193.902 58.5047 193.851 58.7516C193.798 59.0085 193.727 59.2731 193.775 59.5341C194.116 59.6406 194.452 59.4668 194.738 59.2987C195.02 59.1327 195.43 58.8905 195.601 58.5924C195.677 58.4598 195.778 58.0981 195.566 58.0276C195.33 57.9488 195.171 58.263 195.082 58.4222C194.921 58.7114 194.826 59.0387 194.886 59.3728C194.937 59.6542 195.167 59.8202 195.449 59.6876C195.726 59.5571 195.904 59.1922 196.053 58.9463C196.132 58.8174 196.227 58.6874 196.288 58.5486C196.271 58.6911 196.293 58.8383 196.289 58.9813C196.283 59.1797 196.194 59.3373 196.165 59.5278C196.322 59.1275 196.355 58.263 196.898 58.1842C197.012 58.298 196.959 58.6269 196.957 58.7522C196.955 58.8811 196.931 59.0325 196.961 59.1583C197.079 59.1604 197.215 58.8701 197.247 58.82C197.343 58.6697 197.434 58.4818 197.572 58.3664C197.82 58.1571 198.021 58.274 198.071 58.5778C198.113 58.8278 197.995 59.0351 197.929 59.2642C197.909 59.3331 197.876 59.4469 197.899 59.5158C197.927 59.5973 197.951 59.6166 198.049 59.5853C198.232 59.5278 198.379 59.3451 198.565 59.2768C199.062 59.093 199.69 58.9239 199.979 58.4322C200.083 58.2563 200.069 58.0548 199.882 57.9561C199.63 57.822 199.392 57.9926 199.229 58.1905C199.031 58.4311 198.895 58.7052 198.827 59.0079C198.77 59.2585 198.666 59.6443 198.799 59.8927C198.974 60.2195 199.559 59.7779 199.667 59.6824C199.886 59.4882 200.064 59.258 200.256 59.0387",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M203.1 57.0316C203.02 57.0943 203.017 57.1997 203.042 57.2895C203.114 57.2864 203.162 57.242 203.187 57.1554C203.362 56.9565 203.545 56.7644 203.736 56.5796C203.851 56.4658 204.378 55.8504 204.603 55.9793C204.547 56.2659 204.434 56.5269 204.314 56.792C204.037 57.4017 203.752 58.0172 203.57 58.6629C203.52 58.8513 203.471 59.0403 203.421 59.2287C203.413 59.3086 203.405 59.3885 203.396 59.4689C203.461 59.5727 203.593 59.5519 203.676 59.4657",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M189.209 71.5417C189.219 71.4796 189.242 71.4096 189.264 71.3506C189.417 70.9523 189.877 70.4904 190.155 70.2033C190.758 69.5821 191.421 69.0173 192.12 68.4817C192.488 68.1998 192.85 67.8736 193.288 67.682C193.328 67.8725 193.28 68.0511 193.23 68.2379C193.117 68.6686 192.944 69.0825 192.836 69.5158C192.746 69.8708 192.67 70.2299 192.608 70.5896C192.578 70.7655 192.478 71.1126 192.615 71.2875C192.787 71.2541 192.761 70.9946 192.764 70.8939",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M191.405 70.0127C191.762 70.0561 192.138 69.9344 192.477 69.8488C192.987 69.7194 193.487 69.5659 193.966 69.3644",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M194.437 67.7896C194.451 67.7969 194.465 67.8036 194.479 67.811C194.348 68.37 194.151 68.9181 193.979 69.4683C193.848 69.8749 193.731 70.2842 193.627 70.6971C193.511 70.9116 193.492 71.1241 193.572 71.3329C193.641 71.3637 193.702 71.3559 193.757 71.3094",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M194.96 69.4568C194.77 69.9423 194.535 70.4397 194.541 70.9617C194.542 71.05 194.536 71.1523 194.629 71.2013C194.699 71.2384 194.808 71.2212 194.803 71.1241",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M193.967 70.1056C194.142 70.091 194.305 70.1746 194.48 70.1902C194.645 70.2048 194.814 70.2054 194.979 70.2022C195.11 70.2001 195.376 70.2085 195.483 70.1051C195.591 70.0952 195.928 70.447 196.038 70.4434C196.213 70.4376 196.364 70.2769 196.437 70.1479C196.529 69.9851 196.465 69.9036 196.263 69.876C196.031 69.8441 195.866 69.9099 195.743 70.0785C195.555 70.3379 195.421 71.2034 196.019 71.076C196.395 70.9962 196.594 70.7394 196.806 70.4784C197.012 70.2247 197.233 69.9866 197.395 69.7084C197.099 69.9548 197.254 70.4032 197.1 70.6929C197.07 70.2951 197.501 69.6802 198.021 69.8259C198.139 69.8587 198.093 69.9136 198.044 70.0169C197.925 70.2664 197.767 70.4924 197.661 70.7498C197.851 70.5013 197.98 70.2174 198.17 69.9705C198.225 69.8995 198.355 69.71 198.492 69.7272C198.807 69.7669 198.647 70.386 198.682 70.5697C198.852 70.6172 199.152 70.3092 199.211 70.2586C199.449 70.0524 199.662 69.7977 199.947 69.6432C199.883 69.9767 199.404 70.196 199.508 70.5796C199.703 70.5368 199.805 70.2894 199.88 70.1458C199.936 70.0362 199.968 69.8139 200.074 69.7434C200.138 69.8259 200.011 70.0482 200.028 70.1521C200.058 70.3228 200.225 70.5086 200.398 70.577C201.019 70.8208 201.648 69.9934 201.874 69.6066C201.724 69.7282 201.591 70.0639 201.541 70.1892C201.49 70.3301 201.44 70.4705 201.391 70.6115C201.273 70.7889 201.287 70.945 201.434 71.0802C201.527 71.0766 201.619 71.0729 201.712 71.0693C201.915 70.9727 202.075 70.8375 202.188 70.6631C202.302 70.5504 202.388 70.4225 202.446 70.28C202.562 70.1156 202.61 69.9344 202.592 69.7366",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M202.487 68.9938C202.473 68.9964 202.459 68.999 202.444 69.0016C202.424 69.0402 202.423 69.0825 202.444 69.1201C202.538 69.0825 202.589 68.8842 202.445 68.904C202.378 69.0262 202.471 69.0329 202.592 69.0403",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M200.814 70.0592C201.074 70.0592 201.334 70.0587 201.593 70.0602C201.795 70.0613 202.006 70.0738 202.207 70.0514C202.32 70.0383 202.637 69.8342 202.748 69.8274C202.753 69.817 202.757 69.8066 202.762 69.7961C202.853 69.8708 202.814 70.113 202.825 70.2074C202.836 70.3061 202.819 70.8036 203.006 70.8119C203.183 70.6292 203.281 70.374 203.431 70.1709C203.535 70.03 203.638 69.889 203.741 69.7481C203.785 69.6458 203.857 69.5664 203.955 69.5101C203.961 69.6118 203.885 69.7371 203.847 69.8269C203.8 69.936 203.934 70.3714 204.065 70.423C204.33 70.5269 204.574 70.2988 204.715 70.1318C204.786 70.0472 204.94 69.8034 204.824 69.6849C204.641 69.4986 204.213 69.7434 204.065 69.8452C203.826 70.0091 203.256 70.7127 203.794 70.8725C204.109 70.9664 204.379 70.8511 204.617 70.6694C204.783 70.553 204.93 70.4199 205.06 70.2706C205.099 70.1766 205.165 70.1213 205.259 70.1051",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M191.381 73.7931C191.501 73.7409 191.459 73.8964 191.443 73.945C191.294 74.4007 191.075 74.8339 190.915 75.2865C190.779 75.6712 190.561 76.2418 190.595 76.6719C190.577 76.8113 190.625 76.9141 190.74 76.9799C190.81 77.0128 190.867 77.0018 190.913 76.9465",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M190.529 73.7508C190.528 73.7628 190.527 73.7743 190.525 73.7857C190.593 73.804 190.664 73.7993 190.733 73.7988C191.041 73.7962 191.339 73.7502 191.64 73.686C191.938 73.6224 192.233 73.5456 192.534 73.4945C192.63 73.4579 192.726 73.4538 192.823 73.4819C192.923 73.4705 192.982 73.5174 193 73.6229",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M190.316 75.4979C191.04 75.2646 191.713 74.9268 192.49 74.9441",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M193.086 75.37C193.097 75.5167 192.995 75.7109 192.965 75.8456C192.92 76.0476 192.913 76.2318 192.916 76.4354",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M193.469 74.7726C193.469 74.7587 193.469 74.7444 193.469 74.7306",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M193.725 75.37C193.876 75.3366 193.805 75.6347 193.798 75.6738C193.746 75.9573 193.621 76.2183 193.589 76.5069C193.622 76.4714 193.642 76.4276 193.65 76.3764C193.73 76.1974 193.812 76.0189 193.895 75.8414C194.006 75.6232 194.152 75.4321 194.333 75.2677C194.396 75.1722 194.477 75.1309 194.576 75.1445C194.59 75.4681 194.468 75.7949 194.411 76.1123C194.38 76.2814 194.271 76.6108 194.45 76.734",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M195.302 75.3272C195.171 75.7751 194.985 76.2298 194.958 76.699C195.053 76.7283 195.155 76.4709 195.174 76.4354",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M195.685 74.6875C195.685 74.6736 195.685 74.6593 195.685 74.6455",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M196.666 75.157C196.468 75.262 196.28 75.3919 196.109 75.535C196.039 75.5992 195.969 75.6639 195.899 75.7281C195.859 75.784 195.82 75.8398 195.78 75.8957C195.77 76.034 196 76.0142 196.088 76.0277C196.208 76.0465 196.344 76.058 196.417 76.1629C196.515 76.3044 196.412 76.4615 196.316 76.5816C196.245 76.6708 195.811 77.1036 195.814 76.7768",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M197.39 74.9013C197.273 75.1925 197.15 75.4828 197.045 75.7787C197.013 75.8675 196.778 76.4057 196.863 76.4579C196.993 76.307 197.101 76.1415 197.238 75.9949C197.333 75.892 197.527 75.6143 197.686 75.6696C197.747 75.8341 197.782 76.0022 197.866 76.1567C197.957 76.3237 198.153 76.5095 198.372 76.4349C198.708 76.3201 198.937 75.9301 199.043 75.6138C198.939 75.7119 198.888 75.8779 198.842 76.0053C198.759 76.2334 198.623 76.5268 198.626 76.7758",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M199.18 74.5604C199.158 74.5891 199.129 74.6032 199.094 74.6032",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M199.435 76.4354C199.394 76.6082 199.354 76.7815 199.317 76.9553C199.496 76.4417 199.66 75.8027 200.224 75.5809C200.473 75.4833 200.501 75.6712 200.505 75.881C200.512 76.0115 200.506 76.142 200.488 76.2715C200.427 76.3639 200.426 76.4438 200.485 76.5121C200.533 76.4866 200.581 76.461 200.628 76.4349",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M201.353 75.37C201.25 75.489 200.691 76.2381 201.073 76.2303C201.258 76.2266 201.44 75.8967 201.5 75.7829C201.581 75.6305 201.628 75.4598 201.771 75.3549C201.882 75.4139 201.875 75.5767 201.894 75.6858C201.951 76.0283 201.927 76.4391 201.867 76.7836C201.829 76.9971 201.778 77.1855 201.639 77.3547C201.521 77.4982 201.266 77.7033 201.06 77.6778C200.946 77.6637 200.866 77.5765 200.832 77.4711C200.766 77.267 200.91 77.0754 201.036 76.9292C201.197 76.8019 201.358 76.674 201.519 76.5466C201.797 76.3623 202.072 76.1734 202.342 75.9792C202.625 75.7787 202.906 75.5752 203.186 75.3705",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M103.614 181.212C109.321 181.212 125.811 177.487 125.811 177.487H81.4164C81.4164 177.487 97.9069 181.212 103.614 181.212Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5274 186.321H108.701V179.349H98.5274V186.321Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4781 168.591H91.0452V150.672H82.4781V168.591Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0225 217.924H110.205V186.322H97.0225V217.924Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 152.723H102.817C107.159 152.723 110.586 149.035 110.269 144.705L107.348 104.833C107.062 100.929 103.811 97.907 99.8962 97.907H68.808C64.8935 97.907 61.642 100.929 61.3564 104.833L58.4353 144.705C58.1179 149.035 61.5454 152.723 65.8869 152.723Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9843 144.705L67.9054 104.832C68.1915 100.928 71.4425 97.9063 75.357 97.9063H99.8957C103.811 97.9063 107.062 100.928 107.347 104.832L110.268 144.705C110.586 149.035 107.158 152.722 102.817 152.722H72.4359C68.0949 152.723 64.6675 149.035 64.9843 144.705Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4164 224.272C81.4164 224.975 82.0647 225.498 82.7522 225.348C86.7919 224.468 98.8929 221.918 103.614 221.918C108.336 221.918 120.437 224.467 124.477 225.348C125.164 225.498 125.812 224.975 125.812 224.272C125.812 222.908 124.862 221.73 123.529 221.444C118.8 220.428 108.01 218.219 103.615 218.219C99.2197 218.219 88.4294 220.428 83.7006 221.444C82.3664 221.73 81.4164 222.908 81.4164 224.272Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M122.016 228.534C122.016 230.631 123.715 232.33 125.812 232.33C127.909 232.33 129.609 230.631 129.609 228.534C129.609 226.437 127.909 224.737 125.812 224.737C123.715 224.737 122.016 226.437 122.016 228.534ZM123.756 228.534C123.756 227.398 124.677 226.478 125.812 226.478C126.947 226.478 127.868 227.398 127.868 228.534C127.868 229.67 126.947 230.59 125.812 230.59C124.677 230.59 123.756 229.67 123.756 228.534Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8174 228.534C99.8174 230.631 101.517 232.33 103.614 232.33C105.711 232.33 107.41 230.631 107.41 228.534C107.41 226.437 105.711 224.737 103.614 224.737C101.518 224.737 99.8174 226.437 99.8174 228.534ZM101.558 228.534C101.558 227.398 102.479 226.478 103.614 226.478C104.749 226.478 105.67 227.398 105.67 228.534C105.67 229.67 104.749 230.59 103.614 230.59C102.479 230.59 101.558 229.67 101.558 228.534Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0808 228.534C78.0808 230.631 79.7804 232.33 81.8773 232.33C83.9742 232.33 85.6738 230.631 85.6738 228.534C85.6738 226.437 83.9742 224.737 81.8773 224.737C79.781 224.737 78.0808 226.437 78.0808 228.534ZM79.8212 228.534C79.8212 227.398 80.742 226.478 81.8773 226.478C83.0127 226.478 83.9335 227.398 83.9335 228.534C83.9335 229.67 83.0127 230.59 81.8773 230.59C80.742 230.59 79.8212 229.67 79.8212 228.534Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3931 165.78H136.698C139.731 165.78 142.189 168.238 142.189 171.271V171.996C142.189 175.028 139.731 177.487 136.698 177.487H92.3931V165.78Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6081 177.487H97.1923C99.1634 177.487 100.761 175.889 100.761 173.918V169.349C100.761 167.378 99.1634 165.78 97.1923 165.78H68.6081C66.637 165.78 65.0392 167.378 65.0392 169.349V173.918C65.0392 175.889 66.637 177.487 68.6081 177.487Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M169.829 73.8907C166.437 83.4735 155.867 91.6063 151.913 93.1217C150.032 93.8389 125.51 102.824 125.51 102.824C120.145 102.247 117.254 93.9198 117.038 91.6063C116.725 88.2629 116.569 85.6471 121.978 85.3611C130.466 84.908 147.308 82.9343 150.592 80.2272C153.299 77.9946 162.543 70.9408 165.326 68.8106C165.326 68.8106 167.714 69.4792 169.829 73.8907Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M163.715 70.7002L168.971 64.5369L169.138 63.7336C169.714 60.9633 170.796 58.3225 172.33 55.9448L178.006 53.802L182.639 57.385L181.32 60.3437L180.886 62.0674C180.77 62.5246 180.5 62.9281 180.12 63.2085C177.842 65.1649 176.489 65.9161 173.759 67.1668L173.536 67.2691L168.728 75.7819C167.784 77.4001 166.039 77.2252 164.764 75.7077C164.739 75.6769 164.764 75.7083 164.731 75.6853C164.007 75.1842 162.432 72.7715 163.715 70.7002Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M186.159 54.7998L182.298 55.5863L182.414 56.1557L186.275 55.3691L186.159 54.7998Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M184.477 54.7819L180.616 55.5684L180.873 56.8303L184.734 56.0438L184.477 54.7819Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M182.482 54.8611L164.768 58.4693L165.187 60.525L182.901 56.9169L182.482 54.8611Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M185.635 54.8194C185.635 54.8194 187.33 54.4206 187.392 54.8612C187.453 55.2902 185.785 55.5575 185.785 55.5575L185.635 54.8194Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M165.836 59.342C165.955 59.9298 165.748 60.468 165.372 60.5447C164.996 60.6214 164.594 60.207 164.474 59.6192C164.355 59.0314 164.563 58.4932 164.939 58.4165C165.314 58.3403 165.716 58.7548 165.836 59.342Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M175.057 63.5629C174.745 64.0076 174.348 64.3809 173.83 64.6179L175.057 63.5629Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M175.057 63.5629C174.745 64.0076 174.348 64.3809 173.83 64.6179",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M172.095 59.7048C172.319 58.902 173.83 57.1214 178.658 56.5592C179.201 56.8818 178.873 57.7682 178.335 58.0991C177.797 58.4301 177.104 58.5418 176.704 59.0304C176.31 59.5117 176.184 61.1079 175.614 62.5137",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M172.095 59.7048C172.319 58.902 173.83 57.1214 178.658 56.5592C179.201 56.8818 178.873 57.7682 178.335 58.0991C177.797 58.4301 177.104 58.5418 176.704 59.0304C176.31 59.5117 176.184 61.1079 175.614 62.5137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M177.408 55.8963L178.658 56.5592C180.865 57.6737 181.69 56.0941 181.479 55.831L178.333 54.0406",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M177.408 55.8963L178.658 56.5592C180.865 57.6737 181.69 56.0941 181.479 55.831L178.333 54.0406",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M180.473 62.9073L179.223 63.353C178.999 63.4287 178.768 63.4877 178.531 63.53C178.262 63.5775 177.933 63.5806 177.72 63.3316C177.585 63.175 177.536 62.9511 177.56 62.7601C177.584 62.569 177.673 62.4072 177.78 62.2694C178.033 61.94 178.395 61.7213 178.8 61.6529C178.8 61.6529 180.828 60.813 181.32 60.3442L181.257 61.1633C181.206 61.8173 180.928 62.4343 180.473 62.9073Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M179.465 59.1864C178.98 59.2976 178.532 59.5628 178.2 59.9345C178.062 60.09 177.94 60.2691 177.894 60.4721C177.847 60.6752 177.884 60.9064 178.027 61.0578C178.254 61.299 178.643 61.264 178.966 61.1878C179.249 61.121 179.528 61.0364 179.8 60.9346L181.32 60.3437C181.32 60.3437 182.156 60.1401 182.64 57.385L182.369 57.1762L181.792 57.4706C181.792 57.4706 181.305 59.4292 180.509 59.6609C179.712 59.8927 179.465 59.1864 179.465 59.1864Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M181.895 57.1214C181.806 57.4424 181.685 57.8193 181.552 58.1931C181.363 58.7213 181.041 59.1671 180.788 59.4657C180.472 59.8327 179.87 59.7685 179.67 59.33C179.619 59.2141 179.573 59.069 179.539 58.8999C179.469 58.5287 179.604 58.0005 179.771 57.5536L181.895 57.1214Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M179.554 54.7098C180.505 54.8105 181.089 54.7307 181.668 54.8982L179.554 54.7098Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M179.554 54.7098C180.505 54.8105 181.089 54.7307 181.668 54.8982",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M178.779 57.86C178.886 58.3382 178.993 58.8164 179.099 59.2945L178.779 57.86Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M178.779 57.86C178.886 58.3382 178.993 58.8164 179.099 59.2945",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M100.46 83.1937C99.1602 80.9288 98.2708 78.4373 97.8229 75.8701C97.8338 75.6597 97.85 75.3684 97.8714 75.0234C98.0332 76.2423 98.4702 77.423 99.1388 78.4535C99.511 79.036 99.9641 79.5805 100.223 80.2277C100.6 81.1548 100.53 82.1957 100.46 83.1937Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M113.741 232.213H91.2107C90.7445 232.213 90.3473 231.883 90.2591 231.426C89.914 229.635 89.9923 225.63 92.025 220.313L92.2249 209.516L103.767 211.48L102.303 220.683C102.303 220.683 106.95 225.796 109.157 226.712C110.708 227.356 114.233 227.424 114.707 231.133C114.78 231.706 114.319 232.213 113.741 232.213Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8283 223.897C101.151 225.104 102.302 220.683 102.302 220.683C102.302 220.683 106.949 225.796 109.157 226.712C110.708 227.356 114.232 227.424 114.706 231.133C114.78 231.706 114.319 232.213 113.741 232.213H91.2107C90.7445 232.213 90.3473 231.883 90.2591 231.426C89.914 229.635 89.9923 225.63 92.025 220.313C92.025 220.312 92.9933 223.254 95.8283 223.897Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M142.285 225.987L140.364 205.159L151.806 207.172L152.718 223.727L142.285 225.987Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M115.984 144.205C115.984 144.205 118.253 146.532 127.538 148.013C136.823 149.494 156.076 154.149 155.864 161.765C155.653 169.381 152.836 212.589 152.836 212.589C152.836 212.589 143.951 210.896 139.825 208.357C139.825 208.357 137.167 187.081 137.385 169.169C137.385 169.169 113.311 166.207 99.9964 160.707C86.6828 155.206 94.5102 142.687 94.5102 142.687L115.984 144.205Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M100.858 143.136C100.858 143.136 97.4433 148.859 99.9964 152.033C102.55 155.206 117.033 161.131 115.398 168.324C113.763 175.517 108.355 190.736 104.829 214.854C104.829 214.854 96.6264 213.585 91.1256 211.258C91.1256 211.258 90.2136 181.652 96.5935 171.074C96.5935 171.074 78.3261 167.688 76.4751 161.553C74.6241 155.418 78.0876 146.036 78.1539 142.688L100.858 143.136Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M153.974 212.628L153.483 215.364C153.427 215.674 153.196 215.88 152.927 215.853C150.81 215.637 141.967 214.63 138.573 212.546C138.37 212.422 138.251 212.159 138.26 211.894L138.354 208.922C138.368 208.481 138.726 208.205 139.079 208.362C140.557 209.022 144.622 210.504 153.453 211.781C153.796 211.831 154.045 212.232 153.974 212.628Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M105.862 213.434C105.909 213.11 105.595 212.841 105.288 212.955C104.68 213.181 103.649 213.357 102.101 213.003C99.748 212.465 93.0105 210.333 91.0066 209.694C90.7236 209.604 90.4381 209.816 90.4381 210.114V212.921C90.4381 213.094 90.5368 213.25 90.6949 213.321C92.2708 214.022 100.704 217.634 105.117 216.65C105.293 216.611 105.422 216.46 105.448 216.282L105.862 213.434Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4697 146.394C99.3361 146.851 99.2223 147.333 99.1471 147.823",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 230.775C168.469 231.594 167.806 232.258 166.991 232.258C166.991 232.258 151.721 232.358 150.747 232.316C149.913 232.281 148.825 230.945 145.301 230.59C144.485 230.507 144.174 231.263 144.724 232.212L140.363 232.316C139.538 232.316 138.869 231.647 138.88 230.822C138.902 229.032 137.932 225.05 141.359 220.798C141.752 222.389 143.041 223.224 145.004 223.316C152.97 223.678 152.932 219.93 152.932 219.93C152.932 219.93 156.998 224.681 160.217 225.803C162.364 226.552 168.788 228.024 168.469 230.775Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M123.007 113.778C123.003 113.79 123 113.801 122.997 113.811C120.048 124.431 116.212 144.639 116.212 144.639C97.3322 148.622 77.4189 144.639 77.4189 144.639C77.3103 140.234 77.8469 134.423 78.4446 128.319C75.3481 127.462 73.1155 124.605 72.9939 119.858C72.8462 114.106 73.8886 103.748 74.4691 98.9122C74.9796 94.6569 74.6168 92.1273 81.2071 88.9029C84.5098 86.996 89.9949 86.094 96.7423 85.1946C104.599 84.1469 111.803 84.5296 117.079 85.3172C121.816 86.024 125.004 89.1028 125.578 93.6593C126.443 100.536 125.162 106.837 123.007 113.778Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_1394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 84,
    width: 54,
    height: 63
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M123.007 113.778C123.003 113.79 123 113.801 122.997 113.811C120.048 124.431 116.212 144.639 116.212 144.639C97.3322 148.622 77.4189 144.639 77.4189 144.639C77.3103 140.234 77.8469 134.423 78.4446 128.319C75.3481 127.462 73.1155 124.605 72.9939 119.858C72.8462 114.106 73.8886 103.748 74.4691 98.9122C74.9796 94.6569 74.6168 92.1273 81.2071 88.9029C84.5098 86.996 89.9949 86.094 96.7423 85.1946C104.599 84.1469 111.803 84.5296 117.079 85.3172C121.816 86.024 125.004 89.1028 125.578 93.6593C126.443 100.536 125.162 106.837 123.007 113.778Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M77.4188 144.639C77.3405 141.452 77.601 137.524 77.9769 133.287C77.3338 142.269 96.0433 145.079 96.6331 140.211C97.223 135.341 78.4446 128.32 88.6622 130.774C97.5801 132.916 114.856 130.87 119.108 130.315C117.475 137.989 116.212 144.639 116.212 144.639C97.3321 148.622 77.4188 144.639 77.4188 144.639Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6_1394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 84,
    width: 54,
    height: 63
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M123.007 113.778C123.003 113.79 123 113.801 122.997 113.811C120.048 124.431 116.212 144.639 116.212 144.639C97.3322 148.622 77.4189 144.639 77.4189 144.639C77.3103 140.234 77.8469 134.423 78.4446 128.319C75.3481 127.462 73.1155 124.605 72.9939 119.858C72.8462 114.106 73.8886 103.748 74.4691 98.9122C74.9796 94.6569 74.6168 92.1273 81.2071 88.9029C84.5098 86.996 89.9949 86.094 96.7423 85.1946C104.599 84.1469 111.803 84.5296 117.079 85.3172C121.816 86.024 125.004 89.1028 125.578 93.6593C126.443 100.536 125.162 106.837 123.007 113.778Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.179 83.9773C93.9219 89.4985 93.5356 95.7656 95.0975 101.522C97.0398 99.6133 100.206 99.085 102.663 100.259C104.484 101.129 106.309 102.872 108.191 102.142C108.984 101.834 109.55 101.135 110.258 100.667C112.101 99.4478 114.926 100.162 115.968 102.11C115.545 99.1711 114.969 96.2537 114.244 93.3743C113.723 91.3077 113.097 89.202 111.774 87.5305C110.026 85.3204 107.211 84.126 104.403 83.8985C101.594 83.6709 98.7791 84.3228 96.1258 85.2724",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6_1394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 84,
    width: 54,
    height: 63
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M123.007 113.778C123.003 113.79 123 113.801 122.997 113.811C120.048 124.431 116.212 144.639 116.212 144.639C97.3322 148.622 77.4189 144.639 77.4189 144.639C77.3103 140.234 77.8469 134.423 78.4446 128.319C75.3481 127.462 73.1155 124.605 72.9939 119.858C72.8462 114.106 73.8886 103.748 74.4691 98.9122C74.9796 94.6569 74.6168 92.1273 81.2071 88.9029C84.5098 86.996 89.9949 86.094 96.7423 85.1946C104.599 84.1469 111.803 84.5296 117.079 85.3172C121.816 86.024 125.004 89.1028 125.578 93.6593C126.443 100.536 125.162 106.837 123.007 113.778Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.998 99.5031C85.998 99.5031 88.668 107.321 88.6623 111.451C88.6565 115.577 96.1519 118.349 96.166 118.355C92.1519 117.536 88.2442 116.457 86.377 115.918C85.7146 115.727 85.2818 115.098 85.3418 114.411C85.7093 110.177 86.1081 104.474 85.998 99.5031Z",
    fill: "black"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M123.007 113.778C123.003 113.79 123 113.801 122.997 113.811C120.048 124.431 116.212 144.639 116.212 144.639C97.3322 148.622 77.4189 144.639 77.4189 144.639C77.3103 140.234 77.8469 134.423 78.4446 128.319C75.3481 127.462 73.1155 124.605 72.9939 119.858C72.8462 114.106 73.8886 103.748 74.4691 98.9122C74.9796 94.6569 74.6168 92.1273 81.2071 88.9029C84.5098 86.996 89.9949 86.094 96.7423 85.1946C104.599 84.1469 111.803 84.5296 117.079 85.3172C121.816 86.024 125.004 89.1028 125.578 93.6593C126.443 100.536 125.162 106.837 123.007 113.778Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2386 121.629C77.7953 116.467 80.4893 115.174 82.5773 115.044C82.9124 115.023 83.0247 114.584 82.7292 114.424C81.5176 113.767 79.153 113.25 76.2386 116.466",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M128.718 125.129C128.718 125.129 132.446 127.41 130.589 128.466C129.403 129.14 127.248 126.485 125.629 126.374C124.011 126.262 126.453 124.782 126.453 124.782L128.718 125.129Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M102.901 120.038C103.197 119.849 103.563 119.797 103.903 119.884C105.283 120.235 109.24 121.219 110.774 121.384C113.486 121.675 121.686 121.343 121.686 121.343C121.875 121.342 122.061 121.385 122.231 121.467L126.887 123.74C127.057 123.823 127.205 123.944 127.321 124.092C127.321 124.092 128.646 125.622 128.69 125.75L129.131 127.528C128.968 126.854 129.16 127.633 129.165 127.69C129.193 127.97 129.17 128.295 129.091 128.575C128.956 129.058 128.356 129.235 127.95 128.941L127.764 128.335C128.251 129.625 127.871 129.876 127.661 129.969C127.098 130.22 126.44 129.891 126.207 129.321L125.911 128.595C125.911 128.595 125.487 129.97 124.067 128.573C123.88 128.389 123.521 127.539 122.876 126.719C122.876 126.719 121.97 125.546 121.364 125.3C119.997 124.747 119.751 124.483 119.316 124.407C119.316 124.407 123.544 127.669 122.499 128.539C121.453 129.408 118.384 125.895 117.172 125.988C115.985 126.08 115.397 128.922 109.24 126.812C108.967 126.718 108.677 126.68 108.39 126.71C107.248 126.83 104.124 127.157 102.345 127.343C101.591 127.422 100.935 126.87 100.872 126.114C100.728 124.355 100.826 121.37 102.901 120.038Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M121.586 123.682L122.485 123.995C122.922 124.147 123.309 124.418 123.602 124.777L124.854 126.389C124.998 126.566 125.821 128.385 125.912 128.594",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M123.755 123.245C123.755 123.245 125.649 124.184 125.942 124.543L127.108 126.832C127.252 127.009 128.076 128.655 127.92 129.567",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M111.032 122.36C113.349 121.657 116.854 121.224 118.544 121.442",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9593 98.2514C86.1775 103.492 85.7406 109.817 85.3408 114.411C85.2807 115.098 85.7135 115.727 86.3759 115.918C88.9525 116.662 95.4112 118.437 100.677 119.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M102.901 119.532L97.1271 116.936C97.1271 116.936 95.2369 120.78 95.7291 125.712C96.2214 130.645 103.688 126.807 103.688 126.807L102.901 119.532Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M165.325 68.8106L169.829 73.8907L167.011 82.5386L160.097 72.8148L165.325 68.8106Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6654 94.5927C85.7427 95.1924 85.8063 95.8235 85.8565 96.4797",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6855 89.0673C84.3621 89.6493 84.86 90.7278 85.2181 92.1466",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M97.363 98.3719C97.363 98.3719 99.415 95.5359 102.74 98.2514C105.131 100.205 107.509 102.717 107.509 102.717C107.509 102.717 111.399 97.9277 112.806 97.2977C115.744 95.9822 116.352 98.2514 116.352 98.2514C116.352 98.2514 116.016 92.0213 113.558 85.1664C113.558 85.1664 111.001 80.7701 98.9055 82.8351C98.9055 82.8351 96.3738 83.3785 95.8205 85.3193C95.8205 85.3193 94.5421 93.4552 97.363 98.3719Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M113.227 85.5636C113.227 85.5636 112.858 84.3834 110.867 83.7199C108.876 83.0559 103.428 82.6811 99.8821 84.4084C96.3356 86.1352 101.685 94.8197 101.685 94.8197L102.793 96.3398C104.161 98.2169 105.801 99.8795 107.659 101.273L109.958 98.2514C109.958 98.2514 114.039 92.976 113.744 90.1364C113.448 87.2972 113.227 85.5636 113.227 85.5636Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M100.442 83.0784C100.206 83.6228 101.306 92.2275 105.091 94.5927C108.876 96.9579 111.984 92.928 111.984 92.928C111.984 92.928 105.845 97.2262 100.205 83.6228L99.8816 84.4084",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M100.442 83.0784C100.206 83.6228 101.306 92.2275 105.091 94.5927C108.876 96.9579 111.984 92.928 111.984 92.928C111.984 92.928 105.845 97.2262 100.205 83.6228L99.8816 84.4084",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M119.677 79.3931C119.677 79.3931 122.155 69.3628 117.435 64.5443C112.715 59.7257 107.602 58.7422 103.767 61.1027C99.9317 63.4627 98.3584 69.3628 98.9483 72.4113C99.5381 75.4598 99.251 86.3753 104.508 90.8985C109.765 95.4221 113.001 94.3066 116.478 88.1449C118.762 84.0958 119.854 82.9333 119.677 79.3931Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6_1394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 59,
    width: 23,
    height: 35
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M119.677 79.3931C119.677 79.3931 122.155 69.3628 117.435 64.5443C112.715 59.7257 107.602 58.7422 103.767 61.1027C99.9317 63.4627 98.3584 69.3628 98.9483 72.4113C99.5381 75.4598 99.251 86.3753 104.508 90.8985C109.765 95.4221 113.001 94.3066 116.478 88.1449C118.762 84.0958 119.854 82.9333 119.677 79.3931Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.903 79.5998C104.063 79.9292 104.035 80.317 104.13 80.6709C104.394 81.6512 104.92 84.0582 105.933 84.1203C110.29 84.387 111.161 84.0812 113.52 84.897C114.401 85.2019 114.748 86.6431 115.527 86.1305C118.178 84.3865 116.89 87.5853 117.285 86.7407C116.478 88.1449 115.892 90.8943 112.942 92.6555C111.029 93.7971 108.509 93.5889 106.563 92.5047C104.617 91.4205 103.19 89.5768 102.18 87.5911C101.705 86.6577 99.2583 80.7753 100.575 80.3656C101.114 80.198 101.795 81.1715 102.46 80.9272C103.026 80.72 103.22 78.2013 103.903 79.5998Z",
    fill: "black"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M119.677 79.3931C119.677 79.3931 122.155 69.3628 117.435 64.5443C112.715 59.7257 107.602 58.7422 103.767 61.1027C99.9317 63.4627 98.3584 69.3628 98.9483 72.4113C99.5381 75.4598 99.251 86.3753 104.508 90.8985C109.765 95.4221 113.001 94.3066 116.478 88.1449C118.762 84.0958 119.854 82.9333 119.677 79.3931Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M102.652 76.7669C102.652 76.7669 101.65 71.2687 98.8606 71.7787C96.0715 72.2887 98.0656 80.4016 101.346 79.5163",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M102.652 76.7669C102.652 76.7669 101.65 71.2687 98.8606 71.7787C96.0715 72.2887 98.0656 80.4016 101.346 79.5163",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M113.313 88.5876C113.313 88.5876 109.873 88.3574 108.459 85.8685",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M117.722 79.0564C117.623 79.5319 117.748 79.9594 117.999 80.0122C118.251 80.0644 118.535 79.7214 118.634 79.2459C118.733 78.7703 118.608 78.3428 118.357 78.2906C118.105 78.2379 117.821 78.5808 117.722 79.0564Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M111.251 78.5365C111.153 79.012 111.277 79.4395 111.528 79.4922C111.78 79.5444 112.065 79.2015 112.163 78.726C112.262 78.2504 112.138 77.8229 111.886 77.7702C111.634 77.718 111.35 78.0609 111.251 78.5365Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M117.284 77.2899C116.291 77.9111 115.909 79.1978 115.962 80.3676C116.015 81.5374 116.416 82.6597 116.641 83.8092C116.786 84.5525 116.797 85.4582 116.19 85.9113C115.703 86.2746 114.988 86.1733 114.482 85.8356C113.977 85.4979 113.635 84.9717 113.306 84.4606",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M103.143 81.3443C103.789 82.6305 104.128 84.0697 104.122 85.5093",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M109.573 74.3605C109.024 74.4362 108.392 74.6387 108.38 74.9942C108.37 75.2687 108.767 75.489 109.183 75.5663C109.599 75.6435 110.043 75.6185 110.475 75.6404C111.712 75.703 112.82 76.1447 114.034 76.306C115.975 76.5638 115.998 75.513 114.656 74.9978C113.116 74.4069 111.364 74.113 109.573 74.3605Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M118.409 75.4316C117.859 75.4932 117.431 75.6754 117.419 76.0309C117.409 76.3054 117.806 76.5257 118.222 76.603C118.638 76.6802 118.775 76.6291 119.551 76.9799C120.328 77.3317 120.523 77.0738 120.239 75.6644C120.166 75.3016 119.504 75.3089 118.409 75.4316Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M99.6008 127.395C100.076 127.82 99.7996 128.604 99.1623 128.607C95.1784 128.626 84.4288 128.652 80.2601 128.414C75.0976 128.119 79.0381 122.501 83.1891 124.646C87.0148 126.623 95.0625 123.332 99.6008 127.395Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M155.201 165.066C154.304 169.085 151.974 172.787 148.683 175.27",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M155.596 162.06C155.579 162.488 155.545 162.915 155.495 163.341",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M102.943 167.32C103.433 167.187 103.931 167.079 104.432 166.997",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0642 171.332C97.5921 169.78 99.4609 168.571 101.495 167.793",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M151.373 189.979C149.078 195.798 145.824 201.238 141.771 206.002",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M153.051 185.082C152.778 186.015 152.482 186.94 152.162 187.857",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M113.357 173.331C112.662 174.72 111.8 176.027 110.794 177.21",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M102.568 150.937C108.547 153.908 114.586 159.176 115.286 165.38L115.323 165.822C115.234 168 114.735 170.151 113.893 172.161",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5105 149.614C100.05 149.813 100.599 150.034 101.151 150.276",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5781 209.709C100.36 203.801 105.009 196.789 108.198 189.162",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M138.298 163.86C138.995 163.543 139.682 163.197 140.356 162.821",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M115.286 165.38C122.48 167.131 129.752 167.074 136.239 164.703",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M142.941 164.496C143.335 164.198 144.223 163.729 144.223 163.729",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M137.168 169.491C139.054 166.948 139.986 166.599 141.668 165.384",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M126.028 66.3352C125.92 67.5003 124.949 68.5302 123.79 68.6973C124.712 69.6734 124.793 71.3235 123.978 72.3915C123.164 73.4537 121.546 73.8045 120.365 73.1682C119.319 72.3591 117.82 73.0497 116.493 73.0226C114.017 72.9792 108.926 69.5549 108.452 69.3607C107.643 69.0261 107.039 68.3413 106.419 67.7269C105.281 66.6051 103.981 65.6504 102.584 64.8846C102.455 64.8089 102.32 64.739 102.185 64.6633C102.207 65.0678 102.261 65.4666 102.374 65.8226C102.902 66.0706 103.394 66.3671 103.776 66.6369C106.316 68.4222 107.788 71.6575 107.201 74.7426C107.147 75.0229 107.039 75.3413 106.769 75.4222C106.316 75.5569 106.046 74.9529 105.739 74.5969C105.027 73.7878 103.56 74.3328 103.118 75.3142C102.708 76.2256 102.897 77.2664 103.134 78.2426C102.735 76.6353 102.185 75.061 101.489 73.5508C101.096 72.6932 100.476 71.7332 99.5319 71.7228C98.9008 71.7176 98.3292 72.1811 98.0599 72.7527C98.0385 72.8012 98.0165 72.8446 98.0004 72.8931C97.7848 73.4323 97.7738 74.0363 97.8224 74.6136C97.8333 74.7483 97.8495 74.8887 97.8709 75.0234C97.8495 75.3684 97.8333 75.6597 97.8224 75.8701C97.8171 75.9562 97.8114 76.0267 97.8062 76.0857C96.9595 73.8802 96.5711 68.1095 97.4126 65.9041C98.6529 62.652 100.697 59.9397 103.97 58.3972C104.084 58.3377 104.197 58.2839 104.316 58.2354C104.839 58.0036 105.389 57.8308 105.971 57.7337C108.398 57.3239 110.771 58.1221 113.144 58.6128C113.812 58.7532 114.513 58.8931 115.172 58.7208C116.433 58.3972 117.161 57.087 118.288 56.4339C119.394 55.7867 120.817 55.8514 121.988 56.3802C123.153 56.9142 124.086 57.8632 124.83 58.904C125.386 59.6808 125.865 60.5703 125.86 61.525C125.849 62.4797 125.208 63.4825 124.259 63.6067C125.364 63.9841 126.135 65.1707 126.028 66.3352Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M118.887 60.3745C119.194 60.3328 119.502 60.3552 119.795 60.4669",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M109.526 62.0929C111.103 63.6334 113.8 63.85 115.602 62.58C116.275 62.1055 116.816 61.4639 117.482 60.979",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M120.881 64.6591C121.269 64.7176 121.64 64.8465 121.982 65.0741",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M113.043 64.9822C114.133 66.1035 115.987 65.7631 117.468 65.2625C118.209 65.0125 119.011 64.7484 119.792 64.656",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M115.3 67.3996C116.246 67.5416 117.193 67.683 118.139 67.825C118.906 67.9399 119.701 68.0651 120.348 68.4953C120.994 68.9249 121.445 69.7522 121.193 70.4856C120.941 71.2196 119.801 71.5359 119.352 70.9038",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M113.097 67.0692C113.464 67.124 113.831 67.1793 114.198 67.2341",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M141.442 170.592C143.822 168.947 146.267 167.393 148.768 165.937C149.635 165.432 150.581 164.922 151.58 165.016C152.026 165.892 151.468 166.933 150.871 167.714C149.155 169.957 146.954 171.828 144.463 173.159",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3812 112.371C69.4808 113.602 75.7558 113.957 81.955 113.422C82.3157 113.39 82.7229 113.33 82.9296 113.033C83.2386 112.588 82.8805 112.002 82.5835 111.549C81.5035 109.902 81.1621 107.789 81.6679 105.886C76.8645 109.759 70.8182 112.066 64.6554 112.377L63.3812 112.371Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4664 133.046H76.8462V112.386H50.4664V133.046Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6239 112.386H76.7178V133.046H94.6239V112.386Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6599 113.729H75.0094",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3033 113.729H57.9806",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2152 117.592H75.0093",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3033 117.592H60.0159",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6119 121.456H75.0093",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3033 121.456H62.0825",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2152 125.319H75.0093",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3033 125.319H55.7224",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6119 129.182H75.0093",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3033 129.182H56.2826",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7313 113.729H92.7871",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5547 113.729H81.195",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8523 117.592H92.7871",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5547 117.592H82.8001",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4825 121.456H92.7871",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5547 121.456H84.4298",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0154 125.319H92.7871",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5547 125.319H79.4139",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4825 129.182H92.7871",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5547 129.182H79.856",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M51.653 115.812L56.2826 113.75H52.3034L51.653 115.812Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0741 115.812L87.4445 113.75H91.4237L92.0741 115.812Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1668 127.382L83.5372 125.319H90.2721L88.1668 127.382Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7049 124.409L65.7392 121.456H56.1594L63.7049 124.409Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4664 125.545L47.7865 129.219L50.4664 128.885V125.545Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M169.071 133.153H195.45V102.247H169.071V133.153Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M195.322 133.153H213.228V102.247H195.322V133.153Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M190.091 106.111H193.613",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 106.111H182.261",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M184.819 109.974H193.613",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 109.974H176.585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M188.263 113.837H193.613",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 113.837H176.584",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M184.819 117.701H193.613",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 117.701H178.62",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M189.216 121.564H193.614",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 121.564H180.687",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M184.819 125.427H193.613",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 125.427H174.326",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M189.216 129.29H193.614",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M170.907 129.29H174.886",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M206.777 106.111H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 106.111H204.275",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M202.619 109.974H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 109.974H199.799",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M205.335 113.837H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 113.837H199.799",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M204.456 117.701H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 117.701H201.404",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M206.086 121.564H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 121.564H203.034",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M202.619 125.427H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 125.427H198.018",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M206.086 129.29H211.391",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M197.159 129.29H198.46",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M184.788 112.927L191.415 109.974H181.835L184.788 112.927Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M170.257 115.92L174.886 113.857H170.907L170.257 115.92Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M210.678 115.92L206.049 113.857H210.028L210.678 115.92Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M206.771 127.49L202.141 125.427H208.876L206.771 127.49Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M182.309 124.516L184.343 121.564H174.764L182.309 124.516Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M213.228 109.974L215.908 112.729L213.228 112.395V109.974Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07 106.111L164.554 109.784L169.07 109.451V106.111Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07 125.653L166.391 129.327L169.07 128.993V125.653Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M176.856 130.451C176.856 130.451 177.086 128.499 173.351 127.489C166.616 125.667 162.613 129.508 162.577 129.54C160.994 130.954 161.825 133.259 163.811 133.257C164.936 133.255 166.35 133.254 168.125 133.254L176.856 130.451Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M169.05 133.189H175.952C176.451 133.189 176.856 132.784 176.856 132.284V129.898H168.146V132.284C168.146 132.784 168.551 133.189 169.05 133.189Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M176.856 129.912C176.856 128.662 174.907 127.648 172.501 127.648C170.096 127.648 168.146 128.662 168.146 129.912H176.856Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M168.146 129.912C168.146 128.662 170.096 127.648 172.501 127.648V129.912H168.146Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M109.677 132.714H122.688V129.532L109.677 130.896V132.714Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M122.688 132.715H151.609V129.532H122.688V132.715Z",
    fill: "#5C5C5C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M126.569 86.8754H130.242L126.496 122.522H122.822C121.979 122.522 121.368 121.838 121.456 120.995L124.882 88.4023C124.97 87.5592 125.725 86.8754 126.569 86.8754Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M124.534 122.522H170.746C171.589 122.522 172.345 121.838 172.433 120.995L175.859 88.4023C175.948 87.5592 175.336 86.8754 174.493 86.8754H128.281C127.438 86.8754 126.682 87.5592 126.594 88.4023L123.168 120.995C123.079 121.839 123.691 122.522 124.534 122.522Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M140.592 89.5721H144.354",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M127.755 101.63L128.692 93.7841C128.979 91.3813 131.017 89.5721 133.437 89.5721H138.508",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M140.592 133.525H163.574V129.857H140.592V133.525Z",
    fill: "#5C5C5C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M133.867 133.525H140.592V129.857H133.867V133.525Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M152.28 114.323C152.102 112.628 150.783 111.216 149.168 110.824C149.441 110.754 149.725 110.706 150.027 110.706C152.025 110.706 153.814 112.326 154.024 114.323C154.234 116.32 152.785 117.939 150.787 117.939C150.485 117.939 150.191 117.891 149.903 117.821C151.436 117.429 152.458 116.018 152.28 114.323Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M144.085 108.092L146.373 129.857H144.629L142.341 108.092C142.286 107.569 142.665 107.146 143.188 107.146H144.932C144.409 107.146 144.03 107.569 144.085 108.092Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M144.085 108.092L146.373 129.857H157.709L155.421 108.092C155.366 107.569 154.898 107.146 154.375 107.146H144.932C144.409 107.146 144.03 107.569 144.085 108.092ZM150.027 110.706C152.025 110.706 153.814 112.326 154.024 114.323C154.234 116.32 152.785 117.939 150.787 117.939C148.79 117.939 147.001 116.32 146.791 114.323C146.581 112.326 148.03 110.706 150.027 110.706Z",
    fill: "#5C5C5C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1907 149.092L210.876 149.092V138.93H92.1907V149.092Z",
    fill: "#5C5C5C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9414 149.092H92.191V138.93H49.9414V149.092Z",
    fill: "#5C5C5C",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1264 138.93L214.69 138.93V133.189H97.1264V138.93Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1265 138.93H97.1265V133.189H46.1265V138.93Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6_1394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 133,
    width: 52,
    height: 6
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M97.127 133.189H46.1271V138.93H97.127V133.189Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.1264 138.93H97.1263V133.189H46.1264V138.93Z",
    fill: "black"
  }))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1265 138.93H97.1265V133.189H46.1265V138.93Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M204.438 232.317H207.007L207.926 149.092H204.438V232.317Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M201.869 232.317H204.438V149.092H200.951L201.869 232.317Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M170.498 232.317H173.067L173.986 149.092H170.498V232.317Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M167.929 232.317H170.498V149.092H167.011L167.929 232.317Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M90.319 232.317H92.8877L93.8065 149.092H90.319V232.317Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7503 232.317H90.319V149.092H86.8315L87.7503 232.317Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3785 232.317H58.9473L59.866 149.092H56.3785V232.317Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8098 232.317H56.3786V149.092H52.8916L53.8098 232.317Z",
    fill: "#858585",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M105.357 116.936H107.538L109.157 107.58C109.271 106.922 108.765 106.321 108.098 106.321C107.575 106.321 107.128 106.698 107.039 107.213L105.357 116.936Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9273 116.936H101.214L100.346 108.27C100.317 107.981 100.075 107.762 99.7855 107.762H98.6308C98.2978 107.762 98.0373 108.05 98.0702 108.382L98.9273 116.936Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M102.984 116.936H104.438L105.357 106.652H103.902L102.984 116.936Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M100.341 133.364H107.004C108.166 133.364 109.107 132.423 109.107 131.261V111.794H98.2388V131.261C98.2382 132.423 99.1799 133.364 100.341 133.364Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M107.265 117.593V130.627C107.265 131.184 106.813 131.635 106.257 131.635H102.407",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M107.265 114.445V115.92",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7862 232.126H68.0885V208.337H46.7862V232.126Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4441 208.338H67.9847V232.127H82.4441V208.338Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9111 203.488C48.9746 204.877 51.3789 205.606 53.7785 205.57C54.0672 205.566 54.3647 205.548 54.6242 205.405C54.8836 205.261 55.0961 204.961 55.0752 204.634C55.0517 204.26 54.7521 203.996 54.4754 203.79C52.9303 202.642 51.25 201.731 49.494 201.082C48.606 200.753 47.6988 200.491 46.7796 200.3C46.0425 200.147 45.2543 199.787 44.5089 199.794C44.3669 201.401 45.83 202.759 46.9111 203.488Z",
    fill: "#92E3A9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1765 194.248C77.2054 192.928 78.6863 192.074 80.2319 191.909C80.3217 191.899 80.4203 191.895 80.4945 191.953C80.5931 192.032 80.6077 192.189 80.6104 192.326C80.6485 194.398 80.0189 196.477 78.8664 198.083C78.335 198.824 77.6725 199.482 76.8702 199.771C76.2898 199.98 75.5971 199.977 75.0448 199.662C74.4904 199.346 74.5917 198.893 74.6486 198.269C74.7822 196.788 75.3042 195.367 76.1765 194.248Z",
    fill: "#92E3A9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.1765 194.248C77.2054 192.928 78.6863 192.074 80.2319 191.909C80.3217 191.899 80.4203 191.895 80.4945 191.953C80.5931 192.032 80.6077 192.189 80.6104 192.326C80.6485 194.398 80.0189 196.477 78.8664 198.083C78.335 198.824 77.6725 199.482 76.8702 199.771C76.2898 199.98 75.5971 199.977 75.0448 199.662C74.4904 199.346 74.5917 198.893 74.6486 198.269C74.7822 196.788 75.3042 195.367 76.1765 194.248Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2487 196.127C67.0108 195.192 67.5698 193.988 67.5944 192.715C67.6152 191.647 67.2608 190.604 66.7529 189.705C66.2445 188.806 65.5862 188.031 64.9322 187.263C64.7197 189.577 64.6581 191.91 64.7484 194.234C64.7677 194.728 64.798 195.239 65.0052 195.674C65.2125 196.109 65.6484 196.443 66.0733 196.335L66.2487 196.127Z",
    fill: "#92E3A9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1922 189.05C67.7562 190.509 66.8537 192.625 66.7362 194.809C66.695 195.58 66.7545 196.386 67.0854 197.061C67.4164 197.737 68.0673 198.251 68.7454 198.18C69.4532 198.107 70.0013 197.453 70.4012 196.785C71.0652 195.676 71.8722 194.094 71.4937 192.727C71.0886 191.264 70.2874 189.953 69.1922 189.05Z",
    fill: "#92E3A9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.1922 189.05C67.7562 190.509 66.8537 192.625 66.7362 194.809C66.695 195.58 66.7545 196.386 67.0854 197.061C67.4164 197.737 68.0673 198.251 68.7454 198.18C69.4532 198.107 70.0013 197.453 70.4012 196.785C71.0652 195.676 71.8722 194.094 71.4937 192.727C71.0886 191.264 70.2874 189.953 69.1922 189.05Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5493 196.734C74.7207 195.643 75.1994 193.815 75.1466 192.095C75.0939 190.376 74.5824 188.723 74.0755 187.102C72.9334 188.668 72.0026 190.432 71.3251 192.314C71.0656 193.035 70.8407 193.788 70.825 194.567C70.8093 195.346 71.0296 196.161 71.5412 196.681C72.0527 197.2 72.8822 197.339 73.436 196.879C73.3708 196.918 73.305 196.957 73.2398 196.995L73.5493 196.734Z",
    fill: "#92E3A9"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5493 196.734C74.7207 195.643 75.1994 193.815 75.1466 192.095C75.0939 190.376 74.5824 188.723 74.0755 187.102C72.9334 188.668 72.0026 190.432 71.3251 192.314C71.0656 193.035 70.8407 193.788 70.825 194.567C70.8093 195.346 71.0296 196.161 71.5412 196.681C72.0527 197.2 72.8822 197.339 73.436 196.879C73.3708 196.918 73.305 196.957 73.2398 196.995L73.5493 196.734Z",
    fill: "black"
  }))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2214 189.988C76.5137 192.112 76.8008 194.286 76.4422 196.397C76.0836 198.507 74.9482 200.576 73.1719 201.32C72.4327 201.63 71.4821 201.633 70.9862 200.938C70.6527 200.471 70.6198 199.799 70.7696 199.222C70.9194 198.645 71.2279 198.141 71.5312 197.648C72.9484 195.344 75.9019 189.759 76.2021 189.993L76.2214 189.988Z",
    fill: "#92E3A9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2214 189.988C76.5137 192.112 76.8008 194.286 76.4422 196.397C76.0836 198.507 74.9482 200.576 73.1719 201.32C72.4327 201.63 71.4821 201.633 70.9862 200.938C70.6527 200.471 70.6198 199.799 70.7696 199.222C70.9194 198.645 71.2279 198.141 71.5312 197.648C72.9484 195.344 75.9019 189.759 76.2021 189.993L76.2214 189.988Z",
    fill: "#92E3A9"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2214 189.988C76.5137 192.112 76.8008 194.286 76.4422 196.397C76.0836 198.507 74.9482 200.576 73.1719 201.32C72.4327 201.63 71.4821 201.633 70.9862 200.938C70.6527 200.471 70.6198 199.799 70.7696 199.222C70.9194 198.645 71.2279 198.141 71.5312 197.648C72.9484 195.344 75.9019 189.759 76.2021 189.993L76.2214 189.988Z",
    fill: "black"
  }))), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7326 192.859C71.4258 194.118 72.0094 195.479 72.2485 196.939C72.4876 198.399 72.3587 199.971 71.7046 201.257C71.0505 202.543 69.8264 203.49 68.5183 203.501C67.5067 203.508 66.5164 202.895 65.9683 201.933C65.3633 200.87 65.8055 199.906 66.2669 198.866C67.3146 196.503 69.0523 194.643 70.7326 192.859Z",
    fill: "#92E3A9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7701 196.785C84.1329 197.374 84.1193 198.184 83.8756 198.847C83.6323 199.509 83.1902 200.052 82.7298 200.545C79.6009 203.896 75.1535 205.597 70.8762 205.079C70.5202 205.035 70.1177 204.944 69.9335 204.595C69.7299 204.211 69.9131 203.686 70.2258 203.412C70.5385 203.138 70.9425 203.049 71.3288 202.955C73.5191 202.418 75.6128 201.452 77.5254 200.131C79.4438 198.806 81.7234 197.89 83.7701 196.785Z",
    fill: "#92E3A9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.7701 196.785C84.1329 197.374 84.1193 198.184 83.8756 198.847C83.6323 199.509 83.1902 200.052 82.7298 200.545C79.6009 203.896 75.1535 205.597 70.8762 205.079C70.5202 205.035 70.1177 204.944 69.9335 204.595C69.7299 204.211 69.9131 203.686 70.2258 203.412C70.5385 203.138 70.9425 203.049 71.3288 202.955C73.5191 202.418 75.6128 201.452 77.5254 200.131C79.4438 198.806 81.7234 197.89 83.7701 196.785Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2073 196.779C76.5241 196.308 76.923 195.764 77.4429 195.823C77.8453 195.869 78.1423 196.278 78.3094 196.696C78.9869 198.397 78.1763 200.478 76.8812 201.627C75.5856 202.775 73.9225 203.211 72.3179 203.616C71.7677 203.755 71.217 203.894 70.6668 204.033C70.0117 204.199 68.6973 203.978 69.2819 202.941C69.6739 202.246 70.9863 201.85 71.5944 201.439C73.3728 200.237 74.9503 198.648 76.2073 196.779Z",
    fill: "#92E3A9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0173 203.488C80.9538 204.877 78.5495 205.606 76.1499 205.57C75.8612 205.566 75.5637 205.548 75.3042 205.405C75.0448 205.261 74.8323 204.961 74.8532 204.634C74.8767 204.26 75.1763 203.996 75.453 203.79C76.9981 202.642 78.6784 201.731 80.4339 201.082C81.3218 200.753 82.2291 200.491 83.1483 200.3C83.8854 200.147 84.6736 199.787 85.419 199.794C85.5615 201.401 84.0984 202.759 83.0173 203.488Z",
    fill: "#92E3A9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M76.365 209.85C78.3898 209.704 80.3317 208.78 81.9989 207.468C82.3168 207.218 82.665 206.817 82.524 206.408C82.4254 206.121 82.1315 206.001 81.871 205.913C79.9553 205.271 77.9978 204.623 76.0022 204.71C75.06 204.751 74.1141 204.978 73.2518 205.416C72.5779 205.758 71.182 206.597 70.9847 207.503C70.7806 208.44 72.5304 209.124 73.1735 209.375C74.1945 209.773 75.2886 209.928 76.365 209.85Z",
    fill: "#92E3A9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.365 209.85C78.3898 209.704 80.3317 208.78 81.9989 207.468C82.3168 207.218 82.665 206.817 82.524 206.408C82.4254 206.121 82.1315 206.001 81.871 205.913C79.9553 205.271 77.9978 204.623 76.0022 204.71C75.06 204.751 74.1141 204.978 73.2518 205.416C72.5779 205.758 71.182 206.597 70.9847 207.503C70.7806 208.44 72.5304 209.124 73.1735 209.375C74.1945 209.773 75.2886 209.928 76.365 209.85Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3716 204.837C70.3417 204.386 72.3717 204.276 74.371 204.512C74.8674 204.57 75.3748 204.654 75.8127 204.926C76.2507 205.198 76.6119 205.695 76.6281 206.26C76.6443 206.831 76.3092 207.355 75.8874 207.665C75.4656 207.975 74.965 208.11 74.4754 208.239C73.0315 208.619 71.5501 208.988 70.0786 208.789C68.997 208.642 67.7244 208.115 67.0244 207.112C66.1155 205.812 67.3125 205.08 68.3716 204.837Z",
    fill: "#92E3A9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.3716 204.837C70.3417 204.386 72.3717 204.276 74.371 204.512C74.8674 204.57 75.3748 204.654 75.8127 204.926C76.2507 205.198 76.6119 205.695 76.6281 206.26C76.6443 206.831 76.3092 207.355 75.8874 207.665C75.4656 207.975 74.965 208.11 74.4754 208.239C73.0315 208.619 71.5501 208.988 70.0786 208.789C68.997 208.642 67.7244 208.115 67.0244 207.112C66.1155 205.812 67.3125 205.08 68.3716 204.837Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3623 204.819C61.9808 204.527 61.5997 204.199 61.3825 203.738C61.1654 203.278 61.1555 202.653 61.4749 202.277C61.9317 201.74 64.4723 200.977 65.1112 200.829C65.6442 200.706 66.1876 200.931 66.6913 201.165C67.4195 201.502 68.1377 201.867 68.8456 202.256C69.1979 202.45 69.5555 202.657 69.8254 202.979C70.0953 203.302 70.2654 203.766 70.1668 204.196C70.0279 204.803 69.4443 205.112 68.9181 205.301C67.5588 205.789 66.127 206.016 64.7019 205.969C64.7996 205.947 62.994 205.302 62.3623 204.819Z",
    fill: "#92E3A9"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3623 204.819C61.9808 204.527 61.5997 204.199 61.3825 203.738C61.1654 203.278 61.1555 202.653 61.4749 202.277C61.9317 201.74 64.4723 200.977 65.1112 200.829C65.6442 200.706 66.1876 200.931 66.6913 201.165C67.4195 201.502 68.1377 201.867 68.8456 202.256C69.1979 202.45 69.5555 202.657 69.8254 202.979C70.0953 203.302 70.2654 203.766 70.1668 204.196C70.0279 204.803 69.4443 205.112 68.9181 205.301C67.5588 205.789 66.127 206.016 64.7019 205.969C64.7996 205.947 62.994 205.302 62.3623 204.819Z",
    fill: "black"
  }))), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5212 205.82C68.146 206.012 68.7427 206.439 69.0366 207.094C69.3305 207.748 69.2459 208.641 68.7422 209.103C68.3762 209.438 67.8767 209.498 67.4085 209.545C66.8301 209.602 66.2517 209.66 65.6733 209.718C65.3069 209.754 64.9055 209.78 64.6064 209.538C64.2023 209.209 64.1674 208.555 64.171 207.991C64.1741 207.453 64.1804 206.899 64.3657 206.404C64.6027 205.77 65.0454 205.452 65.6216 205.543C66.2465 205.642 66.9084 205.633 67.5212 205.82Z",
    fill: "#92E3A9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7519 194.248C52.723 192.928 51.2421 192.074 49.6965 191.909C49.6067 191.899 49.508 191.895 49.4339 191.953C49.3353 192.032 49.3207 192.189 49.318 192.326C49.2799 194.398 49.9095 196.477 51.062 198.083C51.5934 198.824 52.2559 199.482 53.0582 199.771C53.6386 199.98 54.3313 199.977 54.8836 199.662C55.438 199.346 55.3367 198.893 55.2798 198.269C55.1462 196.788 54.6242 195.367 53.7519 194.248Z",
    fill: "#92E3A9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.7519 194.248C52.723 192.928 51.2421 192.074 49.6965 191.909C49.6067 191.899 49.508 191.895 49.4339 191.953C49.3353 192.032 49.3207 192.189 49.318 192.326C49.2799 194.398 49.9095 196.477 51.062 198.083C51.5934 198.824 52.2559 199.482 53.0582 199.771C53.6386 199.98 54.3313 199.977 54.8836 199.662C55.438 199.346 55.3367 198.893 55.2798 198.269C55.1462 196.788 54.6242 195.367 53.7519 194.248Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6803 196.127C62.9182 195.192 62.3592 193.988 62.3346 192.715C62.3137 191.647 62.6682 190.604 63.1761 189.705C63.6845 188.806 64.3427 188.031 64.9968 187.263C65.2093 189.577 65.2709 191.91 65.1806 194.234C65.1612 194.728 65.131 195.239 64.9237 195.674C64.7165 196.109 64.2812 196.443 63.8557 196.335L63.6803 196.127Z",
    fill: "#92E3A9"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7364 189.05C62.1724 190.509 63.0749 192.625 63.1924 194.809C63.2336 195.58 63.1741 196.386 62.8432 197.061C62.5122 197.737 61.8613 198.251 61.1832 198.18C60.4754 198.107 59.9273 197.453 59.5274 196.785C58.8634 195.676 58.0559 194.094 58.4349 192.727C58.8399 191.264 59.6412 189.953 60.7364 189.05Z",
    fill: "#92E3A9"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.7364 189.05C62.1724 190.509 63.0749 192.625 63.1924 194.809C63.2336 195.58 63.1741 196.386 62.8432 197.061C62.5122 197.737 61.8613 198.251 61.1832 198.18C60.4754 198.107 59.9273 197.453 59.5274 196.785C58.8634 195.676 58.0559 194.094 58.4349 192.727C58.8399 191.264 59.6412 189.953 60.7364 189.05Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3792 196.734C55.2078 195.643 54.7291 193.815 54.7819 192.095C54.8346 190.376 55.3461 188.723 55.853 187.102C56.9951 188.668 57.9259 190.432 58.6034 192.314C58.8629 193.035 59.0878 193.788 59.1035 194.567C59.1192 195.346 58.8989 196.161 58.3873 196.681C57.8758 197.2 57.0463 197.339 56.4925 196.879C56.5577 196.918 56.623 196.957 56.6887 196.995L56.3792 196.734Z",
    fill: "#92E3A9"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3792 196.734C55.2078 195.643 54.7291 193.815 54.7819 192.095C54.8346 190.376 55.3461 188.723 55.853 187.102C56.9951 188.668 57.9259 190.432 58.6034 192.314C58.8629 193.035 59.0878 193.788 59.1035 194.567C59.1192 195.346 58.8989 196.161 58.3873 196.681C57.8758 197.2 57.0463 197.339 56.4925 196.879C56.5577 196.918 56.623 196.957 56.6887 196.995L56.3792 196.734Z",
    fill: "black"
  }))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M53.707 189.988C53.4147 192.112 53.1276 194.286 53.4862 196.397C53.8448 198.507 54.9802 200.576 56.7565 201.32C57.4957 201.63 58.4468 201.633 58.9421 200.938C59.2757 200.471 59.3086 199.799 59.1588 199.222C59.009 198.645 58.7005 198.141 58.3972 197.648C56.9799 195.344 54.0265 189.759 53.7263 189.993L53.707 189.988Z",
    fill: "#92E3A9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M53.707 189.988C53.4147 192.112 53.1276 194.286 53.4862 196.397C53.8448 198.507 54.9802 200.576 56.7565 201.32C57.4957 201.63 58.4468 201.633 58.9421 200.938C59.2757 200.471 59.3086 199.799 59.1588 199.222C59.009 198.645 58.7005 198.141 58.3972 197.648C56.9799 195.344 54.0265 189.759 53.7263 189.993L53.707 189.988Z",
    fill: "#92E3A9"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.707 189.988C53.4147 192.112 53.1276 194.286 53.4862 196.397C53.8448 198.507 54.9802 200.576 56.7565 201.32C57.4957 201.63 58.4468 201.633 58.9421 200.938C59.2757 200.471 59.3086 199.799 59.1588 199.222C59.009 198.645 58.7005 198.141 58.3972 197.648C56.9799 195.344 54.0265 189.759 53.7263 189.993L53.707 189.988Z",
    fill: "black"
  }))), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1958 192.859C58.5021 194.118 57.919 195.479 57.68 196.939C57.4409 198.399 57.5698 199.971 58.2239 201.257C58.8779 202.543 60.1026 203.49 61.4102 203.501C62.4218 203.508 63.412 202.895 63.9596 201.933C64.5646 200.87 64.1225 199.906 63.661 198.866C62.6139 196.503 60.8762 194.643 59.1958 192.859Z",
    fill: "#92E3A9"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1527 196.951C45.7972 197.528 45.8108 198.321 46.0493 198.971C46.2879 199.621 46.7211 200.153 47.1721 200.636C50.2389 203.921 54.5986 205.589 58.7919 205.08C59.1411 205.038 59.5352 204.948 59.7163 204.606C59.9157 204.229 59.7362 203.715 59.4297 203.446C59.1233 203.178 58.7271 203.09 58.3487 202.997C56.2017 202.471 54.1492 201.524 52.2742 200.229C50.3934 198.932 48.1592 198.033 46.1527 196.951Z",
    fill: "#92E3A9"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.1527 196.951C45.7972 197.528 45.8108 198.321 46.0493 198.971C46.2879 199.621 46.7211 200.153 47.1721 200.636C50.2389 203.921 54.5986 205.589 58.7919 205.08C59.1411 205.038 59.5352 204.948 59.7163 204.606C59.9157 204.229 59.7362 203.715 59.4297 203.446C59.1233 203.178 58.7271 203.09 58.3487 202.997C56.2017 202.471 54.1492 201.524 52.2742 200.229C50.3934 198.932 48.1592 198.033 46.1527 196.951Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3615 196.634C53.0498 196.171 52.6589 195.637 52.1484 195.695C51.7532 195.74 51.4619 196.141 51.298 196.553C50.6325 198.222 51.4285 200.266 52.7006 201.393C53.9727 202.521 55.6056 202.948 57.181 203.346C57.7212 203.482 58.2615 203.619 58.8023 203.755C59.4454 203.918 60.7363 203.701 60.1621 202.683C59.7774 202.001 58.4886 201.612 57.8919 201.209C56.1443 200.028 54.5955 198.469 53.3615 196.634Z",
    fill: "#92E3A9"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5635 209.85C51.5387 209.704 49.5968 208.78 47.9295 207.468C47.6116 207.218 47.2635 206.817 47.4044 206.408C47.5031 206.121 47.797 206.001 48.0574 205.913C49.9732 205.271 51.9307 204.623 53.9263 204.71C54.8685 204.751 55.8144 204.978 56.6767 205.416C57.3506 205.758 58.7464 206.597 58.9437 207.503C59.1478 208.44 57.3981 209.124 56.755 209.375C55.734 209.773 54.6399 209.928 53.5635 209.85Z",
    fill: "#92E3A9"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.5635 209.85C51.5387 209.704 49.5968 208.78 47.9295 207.468C47.6116 207.218 47.2635 206.817 47.4044 206.408C47.5031 206.121 47.797 206.001 48.0574 205.913C49.9732 205.271 51.9307 204.623 53.9263 204.71C54.8685 204.751 55.8144 204.978 56.6767 205.416C57.3506 205.758 58.7464 206.597 58.9437 207.503C59.1478 208.44 57.3981 209.124 56.755 209.375C55.734 209.773 54.6399 209.928 53.5635 209.85Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5568 204.837C59.5868 204.386 57.5568 204.276 55.5575 204.512C55.0611 204.57 54.5537 204.654 54.1157 204.926C53.6778 205.198 53.3165 205.695 53.3004 206.26C53.2842 206.831 53.6193 207.355 54.0411 207.665C54.4629 207.975 54.9635 208.11 55.4531 208.239C56.8969 208.619 58.3784 208.988 59.8499 208.789C60.9315 208.642 62.2041 208.115 62.9041 207.112C63.8129 205.812 62.616 205.08 61.5568 204.837Z",
    fill: "#92E3A9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.5568 204.837C59.5868 204.386 57.5568 204.276 55.5575 204.512C55.0611 204.57 54.5537 204.654 54.1157 204.926C53.6778 205.198 53.3165 205.695 53.3004 206.26C53.2842 206.831 53.6193 207.355 54.0411 207.665C54.4629 207.975 54.9635 208.11 55.4531 208.239C56.8969 208.619 58.3784 208.988 59.8499 208.789C60.9315 208.642 62.2041 208.115 62.9041 207.112C63.8129 205.812 62.616 205.08 61.5568 204.837Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5661 204.819C67.9477 204.527 68.3288 204.199 68.5459 203.738C68.7631 203.278 68.773 202.653 68.4535 202.277C67.9968 201.74 65.4562 200.977 64.8173 200.829C64.2843 200.706 63.7409 200.931 63.2372 201.165C62.509 201.502 61.7907 201.867 61.0829 202.256C60.7305 202.45 60.373 202.657 60.1031 202.979C59.8332 203.302 59.663 203.766 59.7617 204.196C59.9006 204.803 60.4841 205.112 61.0103 205.301C62.3696 205.789 63.8015 206.016 65.2265 205.969C65.1289 205.947 66.9345 205.302 67.5661 204.819Z",
    fill: "#92E3A9"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5661 204.819C67.9477 204.527 68.3288 204.199 68.5459 203.738C68.7631 203.278 68.773 202.653 68.4535 202.277C67.9968 201.74 65.4562 200.977 64.8173 200.829C64.2843 200.706 63.7409 200.931 63.2372 201.165C62.509 201.502 61.7907 201.867 61.0829 202.256C60.7305 202.45 60.373 202.657 60.1031 202.979C59.8332 203.302 59.663 203.766 59.7617 204.196C59.9006 204.803 60.4841 205.112 61.0103 205.301C62.3696 205.789 63.8015 206.016 65.2265 205.969C65.1289 205.947 66.9345 205.302 67.5661 204.819Z",
    fill: "black"
  }))), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4072 205.82C61.7824 206.012 61.1858 206.439 60.8919 207.094C60.598 207.748 60.6826 208.641 61.1863 209.103C61.5522 209.438 62.0518 209.498 62.52 209.545C63.0984 209.602 63.6767 209.66 64.2551 209.718C64.6216 209.754 65.023 209.78 65.3221 209.538C65.7261 209.209 65.7611 208.555 65.7574 207.991C65.7543 207.453 65.748 206.899 65.5627 206.404C65.3257 205.77 64.8836 205.452 64.3068 205.543C63.682 205.642 63.0201 205.633 62.4072 205.82Z",
    fill: "#92E3A9"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2682 193.4C65.1612 193.316 65.0547 193.245 64.965 193.21C65.0015 193.195 65.0386 193.188 65.0683 193.192C65.0882 193.192 65.1085 193.199 65.1283 193.21H65.1315C65.1513 193.218 65.168 193.233 65.1847 193.252C65.2014 193.271 65.2181 193.29 65.2317 193.316C65.2448 193.335 65.2552 193.355 65.262 193.381C65.2651 193.385 65.2682 193.393 65.2682 193.4Z",
    fill: "#92E3A9"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.2719 193.4H65.2687C65.1617 193.316 65.0552 193.245 64.9655 193.21C65.002 193.195 65.0391 193.188 65.0688 193.192C65.0886 193.192 65.109 193.199 65.1288 193.21H65.132C65.1518 193.218 65.1685 193.233 65.1852 193.252C65.2019 193.271 65.2186 193.29 65.2322 193.316C65.2452 193.335 65.2557 193.355 65.2625 193.381C65.2651 193.385 65.2682 193.393 65.2719 193.4Z",
    fill: "#92E3A9"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4335 199.292C67.2169 199.875 66.9397 200.447 66.5362 200.886C66.1358 201.33 65.5919 201.636 65.0318 201.617C65.0083 201.617 64.9885 201.617 64.965 201.614H64.9619C64.942 201.617 64.9185 201.617 64.895 201.617C64.3344 201.636 63.7941 201.33 63.3906 200.886C62.9903 200.447 62.7131 199.875 62.4933 199.292C62.2099 198.52 62.0131 197.679 62.1232 196.85C62.2469 195.937 62.7371 195.127 63.3442 194.506C63.5044 194.506 64.0113 193.915 64.1715 193.794C64.1851 193.786 64.1982 193.775 64.2149 193.763C64.2284 193.748 64.2451 193.737 64.265 193.722C64.372 193.634 64.5187 193.505 64.6622 193.396C64.729 193.347 64.7959 193.301 64.8559 193.263C64.8726 193.256 64.8924 193.244 64.9091 193.237C64.929 193.225 64.9493 193.218 64.966 193.21C65.0563 193.244 65.1628 193.316 65.2693 193.399H65.2724C65.4661 193.544 65.6592 193.722 65.7563 193.793C65.9197 193.914 66.4235 194.505 66.5868 194.505C67.1939 195.126 67.6846 195.936 67.8047 196.849C67.9174 197.679 67.7201 198.52 67.4335 199.292Z",
    fill: "#92E3A9"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9649 193.21C64.9482 193.218 64.9284 193.226 64.908 193.237C64.8913 193.244 64.8746 193.252 64.8548 193.264C64.7948 193.302 64.7279 193.347 64.6611 193.396C64.7045 193.275 64.7713 193.2 64.8616 193.192C64.8913 193.188 64.9279 193.195 64.9649 193.21Z",
    fill: "#92E3A9"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4335 199.292C67.2169 199.875 66.9397 200.447 66.5362 200.886C66.1358 201.33 65.5919 201.636 65.0318 201.617C65.0083 201.617 64.9885 201.617 64.965 201.614H64.9619C64.942 201.617 64.9185 201.617 64.895 201.617C64.3344 201.636 63.7941 201.33 63.3906 200.886C62.9903 200.447 62.7131 199.875 62.4933 199.292C62.2099 198.52 62.0131 197.679 62.1232 196.85C62.2469 195.937 62.7371 195.127 63.3442 194.506C63.5044 194.506 64.0113 193.915 64.1715 193.794C64.2718 193.722 64.4717 193.54 64.6617 193.396C64.7718 193.312 64.8752 193.244 64.9655 193.21C65.0558 193.244 65.1654 193.316 65.2724 193.4C65.4661 193.544 65.6592 193.722 65.7563 193.794C65.9197 193.915 66.4235 194.506 66.5868 194.506C67.1939 195.127 67.6846 195.937 67.8047 196.85C67.9174 197.679 67.7201 198.52 67.4335 199.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9649 193.21C64.8746 193.244 64.7713 193.313 64.6611 193.396C64.7045 193.275 64.7713 193.199 64.8616 193.191C64.8913 193.188 64.9279 193.195 64.9649 193.21Z",
    fill: "white"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.272 193.4C65.1655 193.316 65.0554 193.245 64.9651 193.21C65.0016 193.195 65.0387 193.188 65.0684 193.192C65.1582 193.2 65.225 193.275 65.272 193.4Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M139.082 17.1023V25.4214H137.024",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M137.024 25.4214V17.1023",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M137.024 24.1691C126.911 24.1691 118.712 32.3676 118.712 42.4809H155.336C155.336 32.3676 147.137 24.1691 137.024 24.1691Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6_1394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 24,
    width: 38,
    height: 19
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M137.024 24.1691C126.911 24.1691 118.712 32.3676 118.712 42.4809H155.336C155.336 32.3676 147.137 24.1691 137.024 24.1691Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.632 24.4881C134.188 24.3837 134.753 24.3033 135.325 24.2505C144.641 25.1082 151.938 32.9408 151.938 42.4814H148.548C148.548 33.5286 142.123 26.0807 133.632 24.4881Z",
    fill: "#999999"
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M137.024 24.1691C126.911 24.1691 118.712 32.3676 118.712 42.4809H155.336C155.336 32.3676 147.137 24.1691 137.024 24.1691Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupply);
export default __webpack_public_path__ + "static/media/supply.cce77cc9df947af1a8ef8e748c7a74fe.svg";
export { ForwardRef as ReactComponent };